<div class="header-bar">
  <div class="flex">
    <div class="flex-grow-1">
      <h1 *ngIf="createMovementJobStep != 1">
        Create Order
        <ng-container
          *ngIf="vehicleLifeCycleRefurbId > 0 && vehicleLifeCycleRefurbDetailsForNewOrder"
        >
          (Vehicle LifeCycle #{{ vehicleLifeCycleRefurbDetailsForNewOrder.refurbRef }})
        </ng-container>
      </h1>
      <h1 *ngIf="createMovementJobStep == 1">Order Summary</h1>
    </div>

    <div class="flex-shrink-1" *ngIf="createMovementJobStep == 0">
      <div style="padding: 3px 8px; background: #757575; color: white; border-radius: 3px">
        Task {{ getCurrentTaskNumber() }}/{{ getCurrentTaskCount() }}
      </div>
    </div>
  </div>
</div>

<!--Page Content-->
<div class="create-job-panel content-container" style="margin-bottom: 40px">
  <div class="" *ngIf="typeJob == 0">Invalid job type...</div>

  <div
    class=""
    style="position: relative; margin-bottom: 20px; clear: both"
    *ngIf="typeJob == 1 || typeJob == 2 || typeJob == 3 || typeJob == 14 || typeJob == 5"
  >
    <div class="ui-g-12" *ngIf="createMovementJobStep == 0">
      <step-indicator
        [currentValidStep]="currValidStep"
        [steps]="createTaskSteps"
        [activeIndex]="activeStepIndex"
        [class.create-job-steps]="true"
      >
      </step-indicator>

      <div class="ui-g-12" style="margin-bottom: 20px; margin-top: 20px">
        <!--STEP 2 (REQUIREMENTS)-->
        <div *ngIf="false" class="step-panel">
          <div class="dashboard">
            <div class="task-list">
              <div class="card" style="margin-bottom: 1px">
                <div class="ui-g" *ngIf="typeJob == 1">
                  <div class="ui-g-12 please-select">
                    <h2>Select Driven Option…</h2>
                  </div>

                  <div class="ui-g-6 ui-sm-12 job-type-container">
                    <div class="ui-g">
                      <div class="ui-g-12">
                        <div class="ui-g-6">
                          <h2>Plated</h2>
                        </div>
                        <div class="ui-g-6">
                          <img
                            *ngIf="!isPlated"
                            src="assets/images/driven_inactive.png"
                            alt="right"
                            class="icon-right"
                            width="77"
                            height="76"
                          />
                          <img
                            *ngIf="isPlated"
                            src="assets/images/driven_active.png"
                            width="77"
                            alt="right"
                            height="76"
                            class="icon-right"
                          />
                        </div>
                      </div>
                      <div class="ui-g-12">
                        <p-toggleButton
                          onLabel="Selected"
                          offLabel="Select this option"
                          [(ngModel)]="isPlated"
                          [style]="{ width: '50%' }"
                          [disabled]="isDebug || !isMotValid || isDrivenDisabled"
                        ></p-toggleButton>
                      </div>
                      <div class="description-job-type" [class.disable-description]="!isPlated">
                        <div>By selecting this option, you confirm that the vehicle is:</div>
                        <div><i class="fa fa-check" aria-hidden="true"></i>Road worthy</div>
                        <div><i class="fa fa-check" aria-hidden="true"></i>MOTed</div>
                        <div><i class="fa fa-check" aria-hidden="true"></i>Driveable</div>
                      </div>
                    </div>
                  </div>

                  <div class="ui-g-6 ui-sm-12 job-type-container">
                    <div class="left-border"></div>
                    <div class="ui-g">
                      <div class="ui-g-12">
                        <div class="ui-g-6">
                          <h2>Customer Insured</h2>
                        </div>
                        <div class="ui-g-6">
                          <img
                            *ngIf="!isCustomerInsured"
                            src="assets/images/driven_inactive.png"
                            width="77"
                            height="76"
                            class="icon-right"
                          />
                          <img
                            *ngIf="isCustomerInsured"
                            src="assets/images/driven_active.png"
                            width="77"
                            height="76"
                            class="icon-right"
                          />
                        </div>
                      </div>
                      <div class="ui-g-12">
                        <p-toggleButton
                          onLabel="Selected"
                          offLabel="Select this option"
                          [(ngModel)]="isCustomerInsured"
                          [style]="{ width: '50%' }"
                          [disabled]="isDebug || !isMotValid || isDrivenDisabled"
                        ></p-toggleButton>
                      </div>
                      <div
                        class="description-job-type"
                        [class.disable-description]="!isCustomerInsured"
                      >
                        <div>By selecting this option, you confirm that the vehicle is:</div>
                        <div><i class="fa fa-check" aria-hidden="true"></i>Road worthy</div>
                        <div><i class="fa fa-check" aria-hidden="true"></i>MOTed</div>
                        <div><i class="fa fa-check" aria-hidden="true"></i>Driveable</div>
                        <div><i class="fa fa-check" aria-hidden="true"></i>Road Fund Licenced</div>
                        <div>
                          <i class="fa fa-check" aria-hidden="true"></i>Insured by the vehicle owner
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="ui-g" *ngIf="typeJob == 2">
                  <div class="ui-g-12 please-select">
                    <h2>Select Transported Option…</h2>
                  </div>

                  <div class="ui-g-6 ui-sm-12 job-type-container">
                    <div class="ui-g">
                      <div class="ui-g-12">
                        <div class="ui-g-6">
                          <h2>Uncovered</h2>
                        </div>
                        <div class="ui-g-6">
                          <img
                            *ngIf="!isUncovered"
                            src="assets/images/transported_inactive.png"
                            width="149"
                            height="65"
                            class="icon-right"
                          />
                          <img
                            *ngIf="isUncovered"
                            src="assets/images/transported_active.png"
                            width="149"
                            height="65"
                            class="icon-right"
                          />
                        </div>
                      </div>
                      <div class="ui-g-12">
                        <p-toggleButton
                          onLabel="Selected"
                          offLabel="Select this option"
                          [(ngModel)]="isUncovered"
                          [style]="{ width: '50%' }"
                        ></p-toggleButton>
                      </div>
                      <div class="description-job-type" [class.disable-description]="!isUncovered">
                        <div>By selecting this option, you confirm that the vehicle is:</div>
                        <div><i class="fa fa-check" aria-hidden="true"></i>Fully accesible</div>
                        <div><i class="fa fa-check" aria-hidden="true"></i>Driveable</div>
                      </div>
                    </div>
                  </div>

                  <div class="ui-g-6 ui-sm-12 job-type-container">
                    <div class="left-border"></div>
                    <div class="ui-g">
                      <div class="ui-g-12">
                        <div class="ui-g-6">
                          <h2>Covered</h2>
                        </div>
                        <div class="ui-g-6">
                          <img
                            *ngIf="!isCovered"
                            src="assets/images/transported_inactive.png"
                            width="149"
                            height="65"
                            class="icon-right"
                          />
                          <img
                            *ngIf="isCovered"
                            src="assets/images/transported_active.png"
                            width="149"
                            height="65"
                            class="icon-right"
                          />
                        </div>
                      </div>
                      <div class="ui-g-12">
                        <p-toggleButton
                          onLabel="Selected"
                          offLabel="Select this option"
                          [(ngModel)]="isCovered"
                          [style]="{ width: '50%' }"
                        ></p-toggleButton>
                      </div>
                      <div class="description-job-type" [class.disable-description]="!isCovered">
                        <div>By selecting this option, you confirm that the vehicle is:</div>
                        <div><i class="fa fa-check" aria-hidden="true"></i>Fully accessible</div>
                        <div><i class="fa fa-check" aria-hidden="true"></i>Driveable</div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="ui-g" *ngIf="typeJob == 3">
                  <div class="ui-g-12 please-select">
                    <h2>Select Recovery Option…</h2>
                  </div>

                  <div class="ui-g-4 job-type-container">
                    <div class="ui-g">
                      <div class="ui-g-12" style="height: 70px">
                        <div class="ui-g-6">
                          <h2>Skates Only</h2>
                        </div>
                        <div class="ui-g-6">
                          <img
                            *ngIf="!isSkatesOnly"
                            src="assets/images/recovery_inactive.png"
                            alt="right"
                            width="105"
                            height="52"
                            class="icon-right"
                          />
                          <img
                            *ngIf="isSkatesOnly"
                            src="assets/images/recovery_active.png"
                            alt="right"
                            width="105"
                            height="52"
                            class="icon-right"
                          />
                        </div>
                      </div>
                      <div class="ui-g-12">
                        <p-toggleButton
                          onLabel="Selected"
                          offLabel="Select this option"
                          [(ngModel)]="isSkatesOnly"
                          [style]="{ width: '50%' }"
                        ></p-toggleButton>
                      </div>
                      <div class="description-job-type" [class.disable-description]="!isSkatesOnly">
                        <div>Generally for vehicles that are:</div>
                        <div><i class="fa fa-check" aria-hidden="true"></i>Not rollable</div>
                        <div><i class="fa fa-check" aria-hidden="true"></i>Not driveable</div>
                      </div>
                    </div>
                  </div>

                  <div class="ui-g-4 job-type-container">
                    <div class="left-border"></div>
                    <div class="ui-g">
                      <div class="ui-g-12" style="height: 70px">
                        <div class="ui-g-6">
                          <h2>Standard Recovery</h2>
                        </div>
                        <div class="ui-g-6">
                          <img
                            *ngIf="!isRecoveryStandard"
                            src="assets/images/recovery_inactive.png"
                            width="105"
                            height="52"
                            class="icon-right"
                            alt="right"
                          />
                          <img
                            *ngIf="isRecoveryStandard"
                            src="assets/images/recovery_active.png"
                            width="105"
                            height="52"
                            class="icon-right"
                            alt="left"
                          />
                        </div>
                      </div>
                      <div class="ui-g-12">
                        <p-toggleButton
                          onLabel="Selected"
                          offLabel="Select this option"
                          [(ngModel)]="isRecoveryStandard"
                          [style]="{ width: '50%' }"
                        ></p-toggleButton>
                      </div>
                      <div
                        class="description-job-type"
                        [class.disable-description]="!isRecoveryStandard"
                      >
                        <div>Generally for vehicles that are:</div>
                        <div><i class="fa fa-check" aria-hidden="true"></i>Not rollable</div>
                        <div><i class="fa fa-check" aria-hidden="true"></i>Not driveable</div>
                        <div>
                          <i class="fa fa-check" aria-hidden="true"></i>Are more severely damaged
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="ui-g-4 job-type-container">
                    <div class="left-border"></div>
                    <div class="ui-g">
                      <div class="ui-g-12" style="height: 70px">
                        <div class="ui-g-6">
                          <h2>More Equipment Needed</h2>
                        </div>
                        <div class="ui-g-6">
                          <img
                            *ngIf="!isMoreEquipmentNeeded"
                            src="assets/images/recovery_inactive.png"
                            width="105"
                            height="52"
                            class="icon-right"
                          />
                          <img
                            *ngIf="isMoreEquipmentNeeded"
                            src="assets/images/recovery_active.png"
                            width="105"
                            height="52"
                            class="icon-right"
                          />
                        </div>
                      </div>
                      <div class="ui-g-12">
                        <p-toggleButton
                          onLabel="Selected"
                          offLabel="Select this option"
                          [(ngModel)]="isMoreEquipmentNeeded"
                          [style]="{ width: '50%' }"
                        ></p-toggleButton>
                      </div>
                      <div
                        class="description-job-type"
                        [class.disable-description]="!isMoreEquipmentNeeded"
                      >
                        <div>Generally for vehicles that are:</div>
                        <div>
                          <i class="fa fa-check" aria-hidden="true"></i>Have been in a significant
                          accident and require a complex recovery operation
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="ui-g-12 job-type-container">
                    <div class="card">
                      <div class="header">
                        Please give a full account of the situation of the vehicle, the cause of the
                        incident and any other important details:
                      </div>
                      <div style="margin-right: 20px; margin-top: 10px">
                        <textarea
                          pInputTextarea
                          [(ngModel)]="additionalInformation"
                          rows="5"
                          style="width: 100%"
                          id="additionalInformation"
                        ></textarea>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!--STEP 3 (ROUTE & TIMINGS)-->
        <div *ngIf="activeStepIndex == 1" class="ui-g step-panel">
          <div class="ui-g-12 route-container">
            <div>
              <div class="dashboard ui-sm-12 ui-col-6">
                <form [formGroup]="locationsform">
                  <div
                    class="task-list no-border-bottom ui-g-6 ui-sm-12"
                    style="position: relative; margin-right: 20px; margin-bottom: 10px"
                  >
                    <p-panel styleClass="collect-deliver-panel" header="Collection Details">
                      <ul>
                        <li style="margin-top: 0; padding-top: 0">
                          <div class="ui-g-12 mt-1">
                            <div
                              class="ui-g-12 mt-1 vlc-auto-selected-pick-up-container"
                              *ngIf="
                                vehicleLifeCycleRefurbDetailsForNewOrder &&
                                vehicleLifeCycleRefurbId > 0 &&
                                vehicleLifeCycleRefurbDetailsForNewOrder.currentSite > 0
                              "
                            >
                              <p>
                                The pick-up address for this order has been automatically set to the
                                current refurb location for vehicle registration
                                <strong>{{
                                  vehicleLifeCycleRefurbDetailsForNewOrder.vehicleReg
                                }}</strong>
                                and refurb reference
                                <strong>{{
                                  vehicleLifeCycleRefurbDetailsForNewOrder.refurbRef
                                }}</strong
                                >: {{ vehicleLifeCycleRefurbDetailsForNewOrder.fleetPlusSiteName }}
                              </p>
                            </div>
                            <div
                              class="ui-g-12 mt-1 suggested-pick-up-container"
                              *ngIf="
                                suggestedPickUpLocationFromVehiclePreviousDropOff &&
                                showSuggestedPickUpLocationDialog
                              "
                            >
                              <div class="ui-g-9">
                                <p>
                                  This vehicle
                                  <strong>{{ this.registrationNumber.toUpperCase() }}</strong> was
                                  last delivered on
                                  <strong
                                    >{{
                                      suggestedPickUpLocationFromVehiclePreviousDropOff.taskCompletedDate
                                        | date : 'longDate'
                                    }}
                                    <span
                                      class="suggested-pick-up-clickable-text"
                                      (click)="navigateToJobScreen()"
                                      >({{
                                        suggestedPickUpLocationFromVehiclePreviousDropOff.orderNumber
                                      }})</span
                                    ></strong
                                  >
                                  to:<br />
                                  <strong>
                                    <ng-container
                                      *ngIf="
                                        suggestedPickUpLocationFromVehiclePreviousDropOff
                                          .dropOffAddress.businessName
                                      "
                                      >{{
                                        suggestedPickUpLocationFromVehiclePreviousDropOff.dropOffAddress.businessName.trim()
                                      }},
                                    </ng-container>
                                    {{
                                      suggestedPickUpLocationFromVehiclePreviousDropOff
                                        .dropOffAddress.primaryAddress
                                    }}</strong
                                  >
                                </p>
                                <p>Use this location as your pick-up address?</p>
                              </div>
                              <div class="ui-g-3 suggested-pick-up-button-ui-container">
                                <div class="suggested-pick-up-button-ui-center style2023">
                                  <button
                                    type="button"
                                    pButton
                                    label="Yes"
                                    (click)="closeSuggestedPickUpLocationDialog(true)"
                                    class="default-button"
                                  ></button>
                                  <button
                                    type="button"
                                    pButton
                                    label="No"
                                    (click)="closeSuggestedPickUpLocationDialog(false)"
                                    class="outline-button suggested-pick-up-button-no"
                                  ></button>
                                </div>
                              </div>
                            </div>
                            <div
                              class="new-feature-alert-container"
                              *ngIf="
                                systemSettings?.orderCreationScreenCommunicationBannerText?.length >
                                0
                              "
                            >
                              <div class="flex grid-gap-10">
                                <div class="flex-shrink-1 new-feature-alert-icon">
                                  <i class="fa fa-info-circle" style="color: #012169"></i>
                                </div>
                                <div class="flex-grow-1">
                                  {{ systemSettings?.orderCreationScreenCommunicationBannerText }}
                                </div>
                              </div>
                            </div>
                            <div
                              class="ui-g-12 ui-sm-12 mt-1 address-search-container collection-address-search"
                            >
                              <div class="address-search-container-query-fields">
                                <div class="address-search-input">
                                  <div class="search-input" id="searchPickUpContainer">
                                    <span class="search-input-icon">
                                      <i class="las la-search"></i>
                                    </span>
                                    <input
                                      type="text"
                                      placeholder="Quick search address..."
                                      id="searchPickUp"
                                      name="searchPickUp"
                                      [disabled]="isReturnJourney || isFollowOnJourney"
                                    />
                                  </div>
                                </div>
                                <div class="address-search-input-separator">or</div>
                                <div class="address-search-input-buttons">
                                  <button
                                    type="button"
                                    pButton
                                    label="Use Saved Site"
                                    (click)="openSite(true)"
                                    class="ml-1"
                                  ></button>
                                </div>
                              </div>
                              <div
                                class="address-search-container-editor"
                                *ngIf="addressSearchPickupLocation"
                              >
                                <div class="ui-grid ui-grid-responsive ui-fluid">
                                  <div class="ui-g-12">
                                    <div class="ui-g-3">
                                      <label for="pickupBusinessName">Business Name</label>
                                    </div>
                                    <div class="ui-g-9">
                                      <input
                                        pInputText
                                        id="pickupBusinessName"
                                        [(ngModel)]="addressSearchPickupLocation.businessName"
                                        (ngModelChange)="onPickupAddressManualEntry()"
                                        [ngModelOptions]="{ standalone: true }"
                                        [disabled]="disableAddressSearchPickupFields"
                                      />
                                    </div>
                                  </div>
                                  <div class="ui-g-12 mt-3">
                                    <div class="ui-g-3">
                                      <label for="pickupLine1">Address Line 1*</label>
                                    </div>
                                    <div class="ui-g-9">
                                      <input
                                        pInputText
                                        id="pickupLine1"
                                        [(ngModel)]="addressSearchPickupLocation.addressLine1"
                                        (ngModelChange)="onPickupAddressManualEntry()"
                                        [ngModelOptions]="{ standalone: true }"
                                        [disabled]="disableAddressSearchPickupFields"
                                      />
                                    </div>
                                  </div>
                                  <div class="ui-g-12 mt-3">
                                    <div class="ui-g-3">
                                      <label for="pickupLine2">Address Line 2</label>
                                    </div>
                                    <div class="ui-g-9">
                                      <input
                                        pInputText
                                        id="pickupLine2"
                                        [(ngModel)]="addressSearchPickupLocation.addressLine2"
                                        (ngModelChange)="onPickupAddressManualEntry()"
                                        [ngModelOptions]="{ standalone: true }"
                                        [disabled]="disableAddressSearchPickupFields"
                                      />
                                    </div>
                                  </div>
                                  <div class="ui-g-12 mt-3">
                                    <div class="ui-g-3">
                                      <label for="pickupLine3">Address Line 3</label>
                                    </div>
                                    <div class="ui-g-9">
                                      <input
                                        pInputText
                                        id="pickupLine3"
                                        [(ngModel)]="addressSearchPickupLocation.addressLine3"
                                        (ngModelChange)="onPickupAddressManualEntry()"
                                        [ngModelOptions]="{ standalone: true }"
                                        [disabled]="disableAddressSearchPickupFields"
                                      />
                                    </div>
                                  </div>
                                  <div class="ui-g-12 mt-3">
                                    <div class="ui-g-3">
                                      <label for="pickupCity">Town*</label>
                                    </div>
                                    <div class="ui-g-9">
                                      <input
                                        pInputText
                                        id="pickupCity"
                                        [(ngModel)]="addressSearchPickupLocation.city"
                                        (ngModelChange)="onPickupAddressManualEntry()"
                                        [ngModelOptions]="{ standalone: true }"
                                        [disabled]="disableAddressSearchPickupFields"
                                      />
                                    </div>
                                  </div>
                                  <div class="ui-g-12 mt-3">
                                    <div class="ui-g-3">
                                      <label for="pickupPostalCode">Postcode*</label>
                                    </div>
                                    <div class="ui-g-9">
                                      <input
                                        pInputText
                                        [postcodeFormat]
                                        id="pickupPostalCode"
                                        [(ngModel)]="addressSearchPickupLocation.postcode"
                                        (ngModelChange)="onPickupAddressManualEntry()"
                                        [ngModelOptions]="{ standalone: true }"
                                        [disabled]="disableAddressSearchPickupFields"
                                      />
                                      <small
                                        *ngIf="!isPickupPostcodeValidUKPostcodeFormat"
                                        class="text-danger"
                                      >
                                        Please make sure you have entered a valid postcode
                                      </small>
                                    </div>
                                  </div>

                                  <div
                                    *ngIf="disableAddressSearchPickupFields"
                                    class="ui-g-12 mt-3"
                                  >
                                    <div class="ui-g-3">
                                      <label for="pickupPostalCode">What3Words</label>
                                    </div>
                                    <div class="ui-g-9">
                                      <input
                                        pInputText
                                        id="pickupWhat3Words"
                                        [(ngModel)]="addressSearchPickupLocation.what3Words"
                                        (ngModelChange)="onPickupAddressManualEntry()"
                                        [ngModelOptions]="{ standalone: true }"
                                        [disabled]="disableAddressSearchPickupFields"
                                      />
                                    </div>
                                  </div>

                                  <div class="ui-g-12 mt-3">
                                    <div class="ui-g-3">
                                      <div style="padding-top: 2px">Site Hours:</div>
                                    </div>
                                    <div class="ui-g-9">
                                      <overlay-panel-input
                                        [invalid]="pickupSiteHoursFormGroup.invalid"
                                        [overlayPanelRef]="pickupSiteHoursForm"
                                        [text]="
                                          disableAddressSearchPickupFields
                                            ? 'View Opening Hours'
                                            : 'Edit Opening Hours'
                                        "
                                      ></overlay-panel-input>
                                    </div>
                                  </div>
                                </div>
                                <div class="address-search-option-buttons">
                                  <button
                                    type="button"
                                    pButton
                                    label="Confirm Changes"
                                    (click)="savePickupAddressManualEntry()"
                                    *ngIf="displayAddressSearchPickupLocationManualSave"
                                  ></button>
                                  <button
                                    type="button"
                                    pButton
                                    label="Add to Saved Sites"
                                    class="secondary-style"
                                    (click)="openSavedSiteEditDialog(true)"
                                    *ngIf="
                                      !disableAddressSearchPickupFields &&
                                      !displayAddressSearchPickupLocationManualSave &&
                                      addressSearchPickupLocation
                                    "
                                  ></button>
                                </div>
                                <div class="mt-2">
                                  <app-manual-address-entry-alert
                                    [isManualEntry]="displayAddressSearchPickupLocationManualSave"
                                  ></app-manual-address-entry-alert>
                                  <div
                                    class="ui-g-12 mt-1 matched-site-container"
                                    *ngIf="pickupAddressMatchedSite"
                                  >
                                    <div class="ui-g-9">
                                      <p>
                                        This site appears to be similar to one of your saved sites,
                                        is this
                                      </p>
                                      <p>
                                        <strong
                                          >{{
                                            csService.formatSiteAddress(pickupAddressMatchedSite)
                                          }}?</strong
                                        >
                                      </p>
                                    </div>
                                    <div class="ui-g-3 matched-site-button-ui-container">
                                      <div class="matched-site-button-ui-center style2023">
                                        <button
                                          type="button"
                                          pButton
                                          label="Yes"
                                          (click)="closeMatchedSitePickupLocationDialog(true)"
                                          class="default-button"
                                        ></button>
                                        <button
                                          type="button"
                                          pButton
                                          label="No"
                                          (click)="closeMatchedSitePickupLocationDialog(false)"
                                          class="default-button matched-site-button-no"
                                        ></button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>

                        <li><div style="clear: both"></div></li>

                        <li *ngIf="isPickupLocation && locationsform">
                          <div class="">
                            <app-job-time-window
                              [earliestDateTime]="pickupEarliestDateTime"
                              [latestDateTime]="pickupLatestDateTime"
                              [isPickup]="true"
                              (dateTimeWindowChange)="pickupDateTimeWindowChanged($event)"
                              [disabled]="disabledPickupEarliest()"
                              [minutesInterval]="minutesInterval"
                              [locationForm]="locationsform"
                              [isLocationSet]="isPickupLocation"
                              [bypassOrderLimitations]="bypassOrderLimitations"
                              [taskType]="taskType"
                              [organisationId]="userOrgLevel.organisationId"
                            >
                            </app-job-time-window>
                            <app-bank-holiday-warning
                              [earliest]="pickupEarliestDateTime"
                              [latest]="pickupLatestDateTime"
                            ></app-bank-holiday-warning>
                            <app-booking-warnings
                              [earliest]="pickupEarliestDateTime"
                              [latest]="pickupLatestDateTime"
                              [openHours]="task.pickupSiteOpeningHours"
                              [routeTime]="routeTime"
                              [createOrderDefaultLatestDropoffHour]="
                                systemSettings.createOrderDefaultLatestDropoffHour
                              "
                            >
                            </app-booking-warnings>
                          </div>
                          <div class="route-address md-inputfield panel-right-col">
                            <div style="display: none">
                              <datetime-picker
                                [(ngModel)]="pickupEarliestDateTime"
                                name="pickupEarliestDateTime"
                                formControlName="pickupEarliestDateTime"
                                [class.route-calendar]="true"
                                [minutesInterval]="minutesInterval"
                                [disabled]="disabledPickupEarliest()"
                              ></datetime-picker>
                            </div>

                            <div
                              *ngIf="
                                !locationsform.controls['pickupEarliestDateTime'].valid &&
                                locationsform.controls['pickupEarliestDateTime'].dirty &&
                                locationsform.controls['pickupEarliestDateTime'].errors &&
                                locationsform.controls['pickupEarliestDateTime'].errors.error
                              "
                              class="ui-message ui-messages-error ui-corner-all"
                            >
                              {{ locationsform.controls['pickupEarliestDateTime'].errors.error }}
                            </div>
                            <div
                              *ngIf="taxMotPickupEarliestError != ''"
                              class="ui-message ui-messages-error ui-corner-all"
                            >
                              {{ taxMotPickupEarliestError }}
                            </div>
                          </div>
                          <div style="clear: both"></div>
                        </li>

                        <li style="display: none">
                          <!--ToDo: Need to get rid of this, it apparently breaks validation and the new component needs to validate without this-->
                          <div class="panel-left-col mt-1">
                            <div>
                              <p-checkbox
                                label="Pick-up Latest:"
                                [ngModel]="isPickupLatestTime"
                                binary="true"
                                [disabled]="true"
                                name="isPickupLatestTime"
                                formControlName="isPickupLatestTime"
                              >
                              </p-checkbox>
                            </div>
                          </div>

                          <div class="route-address md-inputfield panel-right-col mt-1">
                            <div style="display: none">
                              <datetime-picker
                                [(ngModel)]="pickupLatestDateTime"
                                name="pickupLatestDateTime"
                                formControlName="pickupLatestDateTime"
                                [class.route-calendar]="true"
                                [minutesInterval]="minutesInterval"
                                [disabled]="disabledPickupLatest()"
                              ></datetime-picker>
                            </div>

                            <div
                              *ngIf="
                                !locationsform.controls['pickupLatestDateTime'].valid &&
                                locationsform.controls['pickupLatestDateTime'].dirty &&
                                locationsform.controls['pickupLatestDateTime'].errors &&
                                locationsform.controls['pickupLatestDateTime'].errors.error
                              "
                              class="ui-message ui-messages-error ui-corner-all"
                            >
                              {{ locationsform.controls['pickupLatestDateTime'].errors.error }}
                            </div>
                            <div
                              *ngIf="taxMotPickupLatestError != ''"
                              class="ui-message ui-messages-error ui-corner-all"
                            >
                              {{ taxMotPickupLatestError }}
                            </div>
                          </div>
                        </li>
                        <li>
                          <p-fieldset legend="Requirements">
                            <div
                              class="ui-g"
                              *ngIf="
                                specificStepGroups && specificStepGroups.length >= 0;
                                else noMappingWarning
                              "
                            >
                              <div class="ui-g-8">
                                <p-dropdown
                                  [(ngModel)]="selectedGroupId"
                                  [options]="specificStepGroups"
                                  [hidden]="!specificStepGroups || specificStepGroups.length < 1"
                                  [autoDisplayFirst]="false"
                                  (onChange)="checklistChanged($event.value, _taskType)"
                                  [ngModelOptions]="{ standalone: true }"
                                  [autoWidth]="false"
                                  [style]="{ width: '100%' }"
                                  [ngClass]="{
                                    'input-danger': selectedGroupId === undefined
                                  }"
                                  placeholder="Please select checklist..."
                                ></p-dropdown>
                              </div>
                              <div
                                class="ui-g-3 ui-col-3 ui-g-offset-1"
                                *ngIf="pickupSpecificSteps && pickupSpecificSteps.length > 0"
                              >
                                <p-button
                                  [label]="!showAllPickupSteps ? 'Show All' : 'Hide All'"
                                  [ngClass]="'link'"
                                  [icon]="
                                    showAllPickupSteps ? 'pi pi-angle-up' : 'pi pi-angle-down'
                                  "
                                  (click)="showAllPickupSteps = !showAllPickupSteps"
                                ></p-button>
                              </div>
                            </div>
                            <ul class="ui-g-12" *ngIf="workflow">
                              <li
                                style="border-bottom: 0"
                                *ngFor="let step of workflow.pickupSteps; let i = index"
                              >
                                <ng-container
                                  *ngTemplateOutlet="
                                    step_item;
                                    context: {
                                      step: step,
                                      isPickup: true,
                                      isLastStep: i == workflow.pickupSteps.length - 1
                                    }
                                  "
                                ></ng-container>
                              </li>
                            </ul>
                          </p-fieldset>
                        </li>
                        <li *ngIf="showMoDelPinContainer">
                          <p-fieldset
                            legend="MoDel"
                            class="{{
                              isShowMoDelContainerError ? 'moDel-container-border-error' : ''
                            }} "
                          >
                            <div class="panel-left-col child-div">MoDel PIN Number:</div>
                            <div class="panel-right-col child-div">
                              <input
                                pInputText
                                maxlength="7"
                                (keydown)="inputHelper.allowNumberInputKey($event, false)"
                                (keyup)="inputHelper.fixDigits($event.target)"
                                name="moDelPin"
                                [attr.disabled]="isMoDelPinUnknown ? '' : null"
                                [(ngModel)]="task.moDelPin"
                                class="width-100"
                                formControlName="moDelPin"
                              />
                            </div>
                            <div class="clearfix"></div>
                            <div class="panel-left-col child-div"></div>
                            <div class="panel-right-col child-div" style="padding-top: 0px">
                              <p-checkbox
                                class="mt-1 pull-right moDelPin-checkbox-text-color"
                                label="I don't know my PIN"
                                [(ngModel)]="isMoDelPinUnknown"
                                value="{{ isMoDelPinUnknown }}"
                                name="isMoDelPinUnknown"
                                formControlName="isMoDelPinUnknown"
                                binary="true"
                              ></p-checkbox>
                            </div>
                          </p-fieldset>
                          <label *ngIf="isShowMoDelContainerError" class="moDel-label-error"
                            >You must input a PIN or select the checkbox to proceed</label
                          >
                        </li>
                        <!--Release Code Section-->
                        <li>
                          <p-fieldset legend="Release Code">
                            <div class="panel-left-col child-div">Release Code:</div>
                            <div class="panel-right-col child-div">
                              <input
                                pInputText
                                name="releaseCode"
                                [(ngModel)]="task.releaseCode"
                                class="width-100"
                                formControlName="releaseCode"
                              />
                            </div>
                          </p-fieldset>
                        </li>
                        <li>
                          <div class="panel-left-col mt-1">
                            <p-checkbox
                              label="Pick-up Notes:"
                              [ngModel]="isPickupNotes"
                              binary="true"
                              [disabled]="true"
                              name="isPickupNotes"
                              formControlName="isPickupNotes"
                            >
                            </p-checkbox>
                          </div>
                          <div class="route-address panel-right-col mt-1">
                            <input
                              type="text"
                              name="pickupNotes"
                              pInputText
                              [(ngModel)]="pickupNotes"
                              ngClass="ui-g-12"
                              formControlName="pickupNotes"
                              *ngIf="!isPickupNotesFocus"
                              (focus)="pickupNotesFocus()"
                              [class.route-value-text]="true"
                              id="pickupNotesInput"
                            />
                            <textarea
                              #vcPickupNotes
                              *ngIf="isPickupNotesFocus"
                              pInputTextarea
                              [(ngModel)]="pickupNotes"
                              rows="5"
                              class="ui-g-12"
                              name="pickupNotes"
                              formControlName="pickupNotes"
                              (blur)="pickupNotesUnfocus()"
                              [class.route-value-text]="true"
                              id="pickupNotes"
                              maxlength="2000"
                            ></textarea>
                          </div>
                          <div style="clear: both"></div>
                        </li>

                        <li>
                          <p-fieldset legend="Pick-up Contact">
                            <div class="panel-left-col child-div">Pick-up Contact:</div>
                            <div class="panel-right-col child-div">
                              <input
                                pInputText
                                id="pickupForename"
                                [(ngModel)]="pickupForename"
                                formControlName="pickupForename"
                                placeholder="Forename"
                                ngClass="ui-g-6"
                              />
                              <input
                                pInputText
                                id="pickupSurname"
                                [(ngModel)]="pickupSurname"
                                formControlName="pickupSurname"
                                placeholder="Surname"
                                ngClass="ui-g-6"
                              />
                            </div>
                            <div class="clearfix"></div>
                            <div class="panel-left-col child-div">Pick-up Email:</div>
                            <div class="panel-right-col child-div">
                              <input
                                pInputText
                                id="pickupEmail"
                                [(ngModel)]="pickupEmail"
                                formControlName="pickupEmail"
                                class="width-100"
                              />
                              <div
                                *ngIf="locationsform?.controls?.pickupEmail?.errors?.email"
                                class="text-danger"
                              >
                                A valid email address is required
                              </div>
                            </div>
                            <div class="clearfix"></div>
                            <div class="panel-left-col child-div">Pick-up Secondary Email:</div>
                            <div class="panel-right-col child-div">
                              <input
                                pInputText
                                id="pickupSecondaryEmail"
                                [(ngModel)]="pickupSecondaryEmail"
                                formControlName="pickupSecondaryEmail"
                                class="width-100"
                              />
                              <div
                                *ngIf="locationsform?.controls?.pickupSecondaryEmail?.errors?.email"
                                class="text-danger"
                              >
                                A valid email address is required
                              </div>
                            </div>
                            <div class="clearfix"></div>

                            <div class="panel-left-col child-div">Pick-up Phone Number:</div>
                            <div class="panel-right-col child-div">
                              <input
                                pInputText
                                id="pickupPhone1"
                                [(ngModel)]="pickupPhone1"
                                formControlName="pickupPhone1"
                                class="width-100"
                                [ngClass]="{
                                  'input-danger':
                                    pickupPhone1Error == '' &&
                                    !pickupPhone1 &&
                                    pickupPhone2Error == '' &&
                                    !pickupPhone2
                                }"
                              />
                              <div *ngIf="pickupPhone1Error != ''" class="text-danger">
                                {{ pickupPhone1Error }}
                              </div>
                              <div
                                *ngIf="
                                  pickupPhone1Error == '' &&
                                  !pickupPhone1 &&
                                  pickupPhone2Error == '' &&
                                  !pickupPhone2
                                "
                                class="text-danger-sm"
                              >
                                You must provide a phone number to ensure a smooth handover
                              </div>
                            </div>
                            <div class="clearfix"></div>

                            <div class="panel-left-col child-div">Pick-up Alternative Number:</div>
                            <div class="panel-right-col child-div">
                              <input
                                pInputText
                                id="pickupPhone2"
                                [(ngModel)]="pickupPhone2"
                                formControlName="pickupPhone2"
                                class="width-100"
                              />
                              <div *ngIf="pickupPhone2Error != ''" class="text-danger">
                                {{ pickupPhone2Error }}
                              </div>
                            </div>
                            <div class="clearfix"></div>
                          </p-fieldset>
                        </li>
                        <li *ngIf="isCurrentTaskInspectAndCollect()">
                          <p-fieldset legend="Inspection Contact">
                            <div class="panel-left-col child-div">Inspection Contact:</div>
                            <div class="panel-right-col child-div">
                              <input
                                pInputText
                                id="inspectionContactFullName"
                                [(ngModel)]="inspectionContactFullName"
                                class="width-100"
                                [ngModelOptions]="{ standalone: true }"
                                [ngClass]="{
                                  'input-danger': inspectionContactFullName?.trim().length == 0
                                }"
                              />
                            </div>
                            <div class="clearfix"></div>

                            <div class="panel-left-col child-div">Inspection Email:</div>
                            <div class="panel-right-col child-div">
                              <input
                                pInputText
                                id="inspectionContactEmail"
                                [(ngModel)]="inspectionContactEmail"
                                class="width-100"
                                [ngModelOptions]="{ standalone: true }"
                                [ngClass]="{
                                  'input-danger': inspectionContactEmail?.trim().length == 0
                                }"
                              />
                            </div>
                            <div *ngIf="!isInspectionContactValid()" class="text-danger-sm">
                              Please provide an Inspection Contact
                            </div>
                            <div class="clearfix"></div>
                          </p-fieldset>
                        </li>
                      </ul>
                    </p-panel>
                    <div
                      style="
                        width: 100%;
                        height: 100%;
                        position: absolute;
                        top: 0;
                        left: 0;
                        background: gray;
                        opacity: 0.3;
                      "
                      *ngIf="isSearchPickup"
                    >
                      <img
                        src="assets/images/loader.gif"
                        style="margin-left: 45%; margin-top: 15%"
                        width="50"
                        height="50"
                        alt="load"
                      />
                    </div>
                  </div>
                  <div
                    class="task-list no-border-bottom ui-g-6 ui-sm-12"
                    style="position: relative; margin-right: 20px; margin-bottom: 80px"
                  >
                    <p-panel styleClass="collect-deliver-panel" header="Delivery Details">
                      <ul>
                        <li style="margin-top: 15px; padding-top: 0">
                          <div class="ui-g-12">
                            <div
                              class="ui-g-12 mt-1 suggested-drop-off-container"
                              *ngIf="
                                autoSuggestNearestDropOffLocationsEnabled &&
                                ((suggestedCustomerDropOffLocations &&
                                  suggestedCustomerDropOffLocations.length > 0) ||
                                  loadingSuggestedCustomerDropOffLocations)
                              "
                            >
                              <div
                                class="suggested-drop-off-header"
                                *ngIf="!loadingSuggestedCustomerDropOffLocations"
                              >
                                <span
                                  >Use any of the following sites, near your pick-up, as your
                                  drop-off address:</span
                                >
                                <div
                                  class="suggested-drop-off-header-close"
                                  (click)="closeSuggestedCustomerDropOffLocationDialog()"
                                >
                                  <i class="las la-times"></i>
                                </div>
                              </div>
                              <div
                                class="suggested-drop-off-loading-panel"
                                *ngIf="loadingSuggestedCustomerDropOffLocations"
                              >
                                <div>Loading Suggested Drop-Off Locations</div>
                                <i class="fa fa-spinner fa-spin"></i>
                              </div>
                              <div *ngIf="!loadingSuggestedCustomerDropOffLocations">
                                <div
                                  class="suggested-drop-off-address-item"
                                  [class.suggested-drop-off-address-item-selected]="
                                    suggestedDropOffAddress.selected
                                  "
                                  *ngFor="
                                    let suggestedDropOffAddress of suggestedCustomerDropOffLocations;
                                    let i = index
                                  "
                                  (click)="
                                    selectSuggestedCustomerDropOffLocation(
                                      suggestedDropOffAddress,
                                      i
                                    )
                                  "
                                >
                                  <div class="suggested-drop-off-address-item-distance">
                                    {{ suggestedDropOffAddress.distanceMiles | number : '1.1-1' }}
                                    mi
                                  </div>
                                  <div class="suggested-drop-off-address-item-address-container">
                                    <div class="suggested-drop-off-address-item-address">
                                      <ng-container
                                        *ngIf="suggestedDropOffAddress.siteDetails.businessName"
                                        >{{
                                          suggestedDropOffAddress.siteDetails.businessName.trim()
                                        }},
                                      </ng-container>
                                      <ng-container
                                        *ngIf="!suggestedDropOffAddress.siteDetails.businessName"
                                        >{{ suggestedDropOffAddress.siteDetails.address1.trim() }},
                                      </ng-container>
                                      {{
                                        suggestedDropOffAddress.siteDetails.postcode.toUpperCase()
                                      }}
                                    </div>
                                    <div
                                      class="suggested-drop-off-address-item-capacity"
                                      *ngIf="
                                        suggestedDropOffAddress.siteDetails
                                          .vehicleLifeCycleMaxCapacity > 0
                                      "
                                    >
                                      <span class="vlc-capacity-count"
                                        >{{
                                          suggestedDropOffAddress.siteDetails
                                            .vehicleLifeCycleRefurbsOnSiteCount
                                        }}/{{
                                          suggestedDropOffAddress.siteDetails
                                            .vehicleLifeCycleMaxCapacity
                                        }}</span
                                      >
                                      <i
                                        class="las la-tachometer-alt vlc-capacity-indicator"
                                        [ngClass]="
                                          vehicleLifeCycleCapacityIndicator(
                                            suggestedDropOffAddress.siteDetails
                                          )
                                        "
                                      ></i>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              class="ui-g-12 suggested-drop-off-exceeded-warning-container"
                              *ngIf="suggestedDropOffLocationCapacityExceeded"
                            >
                              <div class="flex grid-gap-10">
                                <div class="flex-shrink-1 suggested-drop-off-exceeded-warning-icon">
                                  <i class="fa fa-warning" style="color: #f97316"></i>
                                </div>
                                <div class="flex-grow-1">
                                  <div class="suggested-drop-off-exceeded-warning-title">
                                    Site at Full Capacity
                                  </div>
                                  <div class="suggested-drop-off-exceeded-warning-text">
                                    This drop-off location has reached its maximum capacity. Please
                                    choose another site.
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              class="ui-g-12 ui-sm-12 mt-1 address-search-container delivery-address-search"
                            >
                              <div class="address-search-container-query-fields">
                                <div class="address-search-input">
                                  <div class="search-input" id="searchDropoffContainer">
                                    <span class="search-input-icon">
                                      <i class="las la-search"></i>
                                    </span>
                                    <input
                                      type="text"
                                      placeholder="Quick search address..."
                                      id="searchDropoff"
                                      name="searchDropoff"
                                      [disabled]="isReturnJourney"
                                    />
                                  </div>
                                </div>
                                <div class="address-search-input-separator">or</div>
                                <div class="address-search-input-buttons">
                                  <button
                                    type="button"
                                    pButton
                                    label="Use Saved Site"
                                    (click)="openSite(false)"
                                    class="ml-1"
                                  ></button>
                                </div>
                              </div>
                              <div
                                class="address-search-container-editor"
                                *ngIf="addressSearchDropoffLocation"
                              >
                                <div class="ui-grid ui-grid-responsive ui-fluid">
                                  <div class="ui-g-12">
                                    <div class="ui-g-3">
                                      <label for="dropoffBusinessName">Business Name</label>
                                    </div>
                                    <div class="ui-g-9">
                                      <input
                                        pInputText
                                        id="dropoffBusinessName"
                                        [(ngModel)]="addressSearchDropoffLocation.businessName"
                                        (ngModelChange)="onDropoffAddressManualEntry()"
                                        [ngModelOptions]="{ standalone: true }"
                                        [disabled]="disableAddressSearchDropoffFields"
                                      />
                                    </div>
                                  </div>
                                  <div class="ui-g-12 mt-3">
                                    <div class="ui-g-3">
                                      <label for="dropoffLine1">Address Line 1*</label>
                                    </div>
                                    <div class="ui-g-9">
                                      <input
                                        pInputText
                                        id="dropoffLine1"
                                        [(ngModel)]="addressSearchDropoffLocation.addressLine1"
                                        (ngModelChange)="onDropoffAddressManualEntry()"
                                        [ngModelOptions]="{ standalone: true }"
                                        [disabled]="disableAddressSearchDropoffFields"
                                      />
                                    </div>
                                  </div>
                                  <div class="ui-g-12 mt-3">
                                    <div class="ui-g-3">
                                      <label for="dropoffLine2">Address Line 2</label>
                                    </div>
                                    <div class="ui-g-9">
                                      <input
                                        pInputText
                                        id="dropoffLine2"
                                        [(ngModel)]="addressSearchDropoffLocation.addressLine2"
                                        (ngModelChange)="onDropoffAddressManualEntry()"
                                        [ngModelOptions]="{ standalone: true }"
                                        [disabled]="disableAddressSearchDropoffFields"
                                      />
                                    </div>
                                  </div>
                                  <div class="ui-g-12 mt-3">
                                    <div class="ui-g-3">
                                      <label for="dropoffLine3">Address Line 3</label>
                                    </div>
                                    <div class="ui-g-9">
                                      <input
                                        pInputText
                                        id="dropoffLine3"
                                        [(ngModel)]="addressSearchDropoffLocation.addressLine3"
                                        (ngModelChange)="onDropoffAddressManualEntry()"
                                        [ngModelOptions]="{ standalone: true }"
                                        [disabled]="disableAddressSearchDropoffFields"
                                      />
                                    </div>
                                  </div>
                                  <div class="ui-g-12 mt-3">
                                    <div class="ui-g-3">
                                      <label for="dropoffCity">Town*</label>
                                    </div>
                                    <div class="ui-g-9">
                                      <input
                                        pInputText
                                        id="dropoffCity"
                                        [(ngModel)]="addressSearchDropoffLocation.city"
                                        (ngModelChange)="onDropoffAddressManualEntry()"
                                        [ngModelOptions]="{ standalone: true }"
                                        [disabled]="disableAddressSearchDropoffFields"
                                      />
                                    </div>
                                  </div>
                                  <div class="ui-g-12 mt-3">
                                    <div class="ui-g-3">
                                      <label for="dropoffPostalCode">Postcode*</label>
                                    </div>
                                    <div class="ui-g-9">
                                      <input
                                        pInputText
                                        [postcodeFormat]
                                        id="dropoffPostalCode"
                                        [(ngModel)]="addressSearchDropoffLocation.postcode"
                                        (ngModelChange)="onDropoffAddressManualEntry()"
                                        [ngModelOptions]="{ standalone: true }"
                                        [disabled]="disableAddressSearchDropoffFields"
                                      />
                                      <small
                                        *ngIf="!isDropoffPostcodeValidUKPostcodeFormat"
                                        class="text-danger"
                                      >
                                        Please make sure you have entered a valid postcode
                                      </small>
                                    </div>
                                  </div>
                                  <div
                                    *ngIf="disableAddressSearchDropoffFields"
                                    class="ui-g-12 mt-3"
                                  >
                                    <div class="ui-g-3">
                                      <label for="dropoffPostalCode">What3Words</label>
                                    </div>
                                    <div class="ui-g-9">
                                      <input
                                        pInputText
                                        id="dropoffWhat3Words"
                                        [(ngModel)]="addressSearchDropoffLocation.what3Words"
                                        (ngModelChange)="onDropoffAddressManualEntry()"
                                        [ngModelOptions]="{ standalone: true }"
                                        [disabled]="disableAddressSearchDropoffFields"
                                      />
                                    </div>
                                  </div>

                                  <div class="ui-g-12 mt-3">
                                    <div class="ui-g-3">
                                      <div style="padding-top: 2px">Site Hours:</div>
                                    </div>
                                    <div class="ui-g-9">
                                      <overlay-panel-input
                                        [invalid]="dropOffSiteHoursFormGroup.invalid"
                                        [overlayPanelRef]="dropOffSiteHoursForm"
                                        [text]="
                                          disableAddressSearchDropoffFields
                                            ? 'View Opening Hours'
                                            : 'Edit Opening Hours'
                                        "
                                      ></overlay-panel-input>
                                    </div>
                                  </div>
                                </div>
                                <div class="address-search-option-buttons">
                                  <button
                                    type="button"
                                    pButton
                                    label="Confirm Changes"
                                    (click)="saveDropoffAddressManualEntry()"
                                    *ngIf="displayAddressSearchDropoffLocationManualSave"
                                  ></button>
                                  <button
                                    type="button"
                                    pButton
                                    label="Add to Saved Sites"
                                    class="secondary-style"
                                    (click)="openSavedSiteEditDialog(false)"
                                    *ngIf="
                                      !disableAddressSearchDropoffFields &&
                                      !displayAddressSearchDropoffLocationManualSave &&
                                      addressSearchDropoffLocation
                                    "
                                  ></button>
                                </div>
                                <div class="mt-2">
                                  <app-manual-address-entry-alert
                                    [isManualEntry]="displayAddressSearchDropoffLocationManualSave"
                                  ></app-manual-address-entry-alert>
                                  <div
                                    class="ui-g-12 mt-1 matched-site-container"
                                    *ngIf="dropoffAddressMatchedSite"
                                  >
                                    <div class="ui-g-9">
                                      <p>
                                        This site appears to be similar to one of your saved sites,
                                        is this
                                      </p>
                                      <p>
                                        <strong
                                          >{{
                                            csService.formatSiteAddress(dropoffAddressMatchedSite)
                                          }}?</strong
                                        >
                                      </p>
                                    </div>
                                    <div class="ui-g-3 matched-site-button-ui-container">
                                      <div class="matched-site-button-ui-center style2023">
                                        <button
                                          type="button"
                                          pButton
                                          label="Yes"
                                          (click)="closeMatchedSiteDropoffLocationDialog(true)"
                                          class="default-button"
                                        ></button>
                                        <button
                                          type="button"
                                          pButton
                                          label="No"
                                          (click)="closeMatchedSiteDropoffLocationDialog(false)"
                                          class="default-button matched-site-button-no"
                                        ></button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>
                        <li><div style="clear: both"></div></li>
                        <li>
                          <div class="mt-1">
                            <app-job-time-window
                              [earliestDateTime]="dropoffEarliestDateTime"
                              [latestDateTime]="dropoffLatestDateTime"
                              [isPickup]="false"
                              (dateTimeWindowChange)="dropoffDateTimeWindowChanged($event)"
                              [disabled]="disabledDropoffEarliest()"
                              [minutesInterval]="minutesInterval"
                              [locationForm]="locationsform"
                              [isLocationSet]="isDropoffLocation"
                              [bypassOrderLimitations]="bypassOrderLimitations"
                              [organisationId]="userOrgLevel.organisationId"
                            >
                            </app-job-time-window>
                            <app-bank-holiday-warning
                              [earliest]="dropoffEarliestDateTime"
                              [latest]="dropoffLatestDateTime"
                            ></app-bank-holiday-warning>
                            <app-booking-warnings
                              [earliest]="dropoffEarliestDateTime"
                              [latest]="dropoffLatestDateTime"
                              [openHours]="task.dropOffSiteOpeningHours"
                              [routeTime]="routeTime"
                              [createOrderDefaultLatestDropoffHour]="
                                systemSettings.createOrderDefaultLatestDropoffHour
                              "
                            >
                            </app-booking-warnings>
                            <div class="my-2" *ngIf="showCarryoverWarning">
                              <app-warning-container warningTitle="Schedule Warning">
                                <span>
                                  Please note that the collection and delivery are scheduled on
                                  separate days. Please ensure this is acceptable.
                                </span>
                              </app-warning-container>
                            </div>
                          </div>
                          <div class="route-address md-inputfield panel-right-col">
                            <div style="display: none">
                              n

                              <datetime-picker
                                [ngModel]="dropoffEarliestDateTime"
                                name="dropoffEarliestDateTime"
                                formControlName="dropoffEarliestDateTime"
                                [class.route-calendar]="true"
                                [minutesInterval]="minutesInterval"
                                [disabled]="disabledPickupLatest()"
                              ></datetime-picker>
                            </div>

                            <div
                              *ngIf="
                                !locationsform.controls['dropoffEarliestDateTime'].valid &&
                                locationsform.controls['dropoffEarliestDateTime'].dirty &&
                                locationsform.controls['dropoffEarliestDateTime'].errors &&
                                locationsform.controls['dropoffEarliestDateTime'].errors.error
                              "
                              class="ui-message ui-messages-error ui-corner-all"
                            >
                              {{ locationsform.controls['dropoffEarliestDateTime'].errors.error }}
                            </div>
                            <div
                              *ngIf="taxMotDropoffEarliestError != ''"
                              class="ui-message ui-messages-error ui-corner-all"
                            >
                              {{ taxMotDropoffEarliestError }}
                            </div>
                          </div>
                        </li>
                        <li>
                          <div class="panel-left-col mt-1">
                            <div style="display: none">
                              <p-checkbox
                                label="Drop-off Latest:"
                                [ngModel]="isDropoffLatestTime"
                                binary="true"
                                [disabled]="true"
                                name="isDropoffLatestTime"
                                formControlName="isDropoffLatestTime"
                              >
                              </p-checkbox>
                            </div>
                          </div>
                          <div class="route-address md-inputfield panel-right-col">
                            <div style="display: none">
                              <datetime-picker
                                [ngModel]="dropoffLatestDateTime"
                                name="dropoffLatestDateTime"
                                formControlName="dropoffLatestDateTime"
                                [class.route-calendar]="true"
                                [minutesInterval]="minutesInterval"
                                [minDate]="dropoffEarliestDateTime"
                                [disabled]="disabledDropoffLatest()"
                              ></datetime-picker>
                            </div>

                            <div
                              *ngIf="
                                !locationsform.controls['dropoffLatestDateTime'].valid &&
                                locationsform.controls['dropoffLatestDateTime'].dirty &&
                                locationsform.controls['dropoffLatestDateTime'].errors &&
                                locationsform.controls['dropoffLatestDateTime'].errors.error
                              "
                              class="ui-message ui-messages-error ui-corner-all"
                            >
                              {{ locationsform.controls['dropoffLatestDateTime'].errors.error }}
                            </div>
                            <div
                              *ngIf="taxMotDropoffLatestError != ''"
                              class="ui-message ui-messages-error ui-corner-all"
                            >
                              {{ taxMotDropoffLatestError }}
                            </div>
                          </div>
                          <div style="clear: both"></div>
                        </li>

                        <li>
                          <p-fieldset legend="Standard Requirements">
                            <div
                              ngClass="ui-g-3 ui-g-offset-9"
                              *ngIf="dropoffSpecificSteps && dropoffSpecificSteps.length > 0"
                            >
                              <p-button
                                [label]="!showAllDropOffSteps ? 'Show All' : 'Hide All'"
                                [ngClass]="'link'"
                                [icon]="showAllDropOffSteps ? 'pi pi-angle-up' : 'pi pi-angle-down'"
                                (click)="showAllDropOffSteps = !showAllDropOffSteps"
                              ></p-button>
                            </div>
                            <div class="ui-g-12">
                              <ul *ngIf="workflow">
                                <li
                                  style="border-bottom: 0px"
                                  *ngFor="let step of workflow.dropoffSteps; let i = index"
                                >
                                  <ng-container
                                    *ngTemplateOutlet="
                                      step_item;
                                      context: {
                                        step: step,
                                        isPickup: false,
                                        isLastStep: i == workflow.dropoffSteps.length - 1
                                      }
                                    "
                                  ></ng-container>
                                </li>
                              </ul>
                            </div>
                          </p-fieldset>
                          <div class="clearfix"></div>
                        </li>

                        <!-- This code was dropped from EC  -->

                        <li *ngIf="dropoffSpecificSteps && dropoffSpecificSteps.length > 0">
                          <div class="panel-left-col">
                            <p-checkbox
                              label="Standard Requirements:"
                              binary="true"
                              [disabled]="true"
                              name="isPickupRequirements"
                              [ngModel]="selectedDropoffSpecificSteps.length > 0"
                              formControlName="isDropoffSpecificStepGroup"
                            >
                            </p-checkbox>
                          </div>
                          <div class="route-address panel-right-col">
                            <ul>
                              <li
                                style="border-bottom: 0px"
                                *ngFor="
                                  let dropoffSpecificStep of dropoffSpecificSteps;
                                  let i = index
                                "
                              >
                                <p-checkbox
                                  name="dropoffSpecificStepGroup"
                                  value="{{ dropoffSpecificStep.id }}"
                                  label="{{ dropoffSpecificStep.name }}"
                                  [(ngModel)]="selectedDropoffSpecificSteps"
                                  formControlName="dropoffSpecificStepGroup"
                                >
                                </p-checkbox>
                              </li>
                            </ul>
                          </div>
                          <div style="clear: both"></div>
                        </li>

                        <!-- END CODE WAS DROPPED FROM EC -->

                        <li>
                          <div class="panel-left-col">
                            <p-checkbox
                              label="Drop-off Notes:"
                              [ngModel]="isDropoffNotes"
                              binary="true"
                              [disabled]="true"
                              name="isDropoffNotes"
                              formControlName="isDropoffNotes"
                            >
                            </p-checkbox>
                          </div>
                          <div class="route-address panel-right-col">
                            <input
                              type="text"
                              name="dropoffNotes"
                              pInputText
                              [(ngModel)]="dropoffNotes"
                              style="width: 100%"
                              formControlName="dropoffNotes"
                              id="dropoffNotesInput"
                              *ngIf="!isDropoffNotesFocus"
                              (focus)="dropoffNotesFocus()"
                              [class.route-value-text]="true"
                            />
                            <textarea
                              #vcDropoffNotes
                              *ngIf="isDropoffNotesFocus"
                              pInputTextarea
                              [(ngModel)]="dropoffNotes"
                              rows="5"
                              style="width: 100%"
                              name="dropoffNotes"
                              formControlName="dropoffNotes"
                              (blur)="dropoffNotesUnfocus()"
                              [class.route-value-text]="true"
                              id="dropoffNotes"
                              maxlength="2000"
                            >
                            </textarea>
                          </div>
                          <div style="clear: both"></div>
                        </li>

                        <li>
                          <p-fieldset legend="Drop-off Contact">
                            <div class="panel-left-col child-div">Drop-off Contact:</div>
                            <div class="panel-right-col child-div">
                              <input
                                pInputText
                                id="dropoffForename"
                                [(ngModel)]="dropoffForename"
                                formControlName="dropoffForename"
                                placeholder="Forename"
                                ngClass="ui-g-6"
                                [required]="task.dropoffNotification"
                              />
                              <input
                                pInputText
                                id="dropoffSurname"
                                [(ngModel)]="dropoffSurname"
                                formControlName="dropoffSurname"
                                placeholder="Surname"
                                ngClass="ui-g-6"
                                [required]="task.dropoffNotification"
                              />
                            </div>

                            <div class="clearfix"></div>
                            <div class="panel-left-col child-div">Drop-off Email:</div>
                            <div class="panel-right-col child-div">
                              <input
                                pInputText
                                id="dropoffEmail"
                                [(ngModel)]="dropoffEmail"
                                formControlName="dropoffEmail"
                                class="width-100"
                              />
                              <div
                                *ngIf="locationsform?.controls?.dropoffEmail?.errors?.email"
                                class="text-danger"
                              >
                                A valid email address is required
                              </div>
                            </div>

                            <div class="clearfix"></div>
                            <div class="panel-left-col child-div">Drop-off Secondary Email:</div>
                            <div class="panel-right-col child-div">
                              <input
                                pInputText
                                id="dropoffSecondaryEmail"
                                [(ngModel)]="dropoffSecondaryEmail"
                                formControlName="dropoffSecondaryEmail"
                                class="width-100"
                              />
                              <div
                                *ngIf="
                                  locationsform?.controls?.dropoffSecondaryEmail?.errors?.email
                                "
                                class="text-danger"
                              >
                                A valid email address is required
                              </div>
                            </div>

                            <div class="clearfix"></div>
                            <div class="panel-left-col child-div">Drop-off Phone Number:</div>
                            <div class="panel-right-col child-div">
                              <input
                                pInputText
                                id="dropoffPhone1"
                                [(ngModel)]="dropoffPhone1"
                                formControlName="dropoffPhone1"
                                class="width-100"
                                [ngClass]="{
                                  'input-danger':
                                    dropoffPhone1Error == '' &&
                                    !dropoffPhone1 &&
                                    !dropoffPhone2 &&
                                    dropoffPhone2Error == ''
                                }"
                                [required]="task.dropoffNotification"
                              />
                              <div *ngIf="dropoffPhone1Error != ''" class="text-danger">
                                {{ dropoffPhone1Error }}
                              </div>
                              <div
                                *ngIf="
                                  dropoffPhone1Error == '' &&
                                  !dropoffPhone1 &&
                                  !dropoffPhone2 &&
                                  dropoffPhone2Error == ''
                                "
                                class="text-danger-sm"
                              >
                                You must provide a phone number to ensure a smooth handover
                              </div>
                            </div>
                            <div class="clearfix"></div>
                            <div class="clearfix"></div>
                            <div class="panel-left-col child-div">Drop-off Alternative Number:</div>
                            <div class="panel-right-col child-div">
                              <input
                                pInputText
                                id="dropoffPhone2"
                                [(ngModel)]="dropoffPhone2"
                                formControlName="dropoffPhone2"
                                class="width-100"
                              />
                              <div *ngIf="dropoffPhone2Error != ''" class="text-danger">
                                {{ dropoffPhone2Error }}
                              </div>
                            </div>
                            <div class="clearfix"></div>
                            <div class="panel-left-col child-div">Drop-off Notification:</div>
                            <div class="panel-right-col child-div">
                              <p-checkbox
                                name="dropoffNotification"
                                formControlName="dropoffNotification"
                                [(ngModel)]="task.dropoffNotification"
                                binary="true"
                                value="{{ dropoffNotification }}"
                              >
                              </p-checkbox>
                            </div>

                            <div class="clearfix"></div>
                          </p-fieldset>
                        </li>
                      </ul>
                    </p-panel>
                    <div
                      style="
                        width: 100%;
                        height: 100%;
                        position: absolute;
                        top: 0;
                        left: 0;
                        background: gray;
                        opacity: 0.3;
                      "
                      *ngIf="isSearchDropoff"
                    >
                      <img
                        src="assets/images/loader.gif"
                        style="margin-left: 45%; margin-top: 15%"
                        width="50"
                        height="50"
                        alt="load"
                      />
                    </div>
                  </div>
                </form>
              </div>
              <div id="ajustementMap" class="ui-sm-12 ui-col-6">
                <div>
                  <map-control
                    [readOnlyMode]="getReadOnlyMode()"
                    [(origin)]="originMarkerPoint"
                    [(destination)]="destinationMarkerPoint"
                    [earliestPickup]="pickupEarliestDateTime"
                    [customStyle]="{ height: '773px' }"
                  >
                  </map-control>
                </div>
              </div>
              <div style="clear: both"></div>
            </div>
          </div>
        </div>

        <!--STEP 1 (VEHICLE)-->
        <div *ngIf="activeStepIndex == 0" class="step-panel">
          <div style="height: auto; padding-top: 10px; padding-bottom: 10px; margin-bottom: 0px">
            <div ngClass="grid">
              <div [hidden]="!showOrderCreationMessage" class="col-12">
                <div class="order-message-div">
                  <div class="icon-container">
                    <span class="icon">i</span>
                  </div>
                  <div class="message-container">
                    <!-- using quill-editor here as the primeng wrapper has issues with ViewEncapsulation.None -->
                    <quill-editor
                      [(ngModel)]="createOrderMessage"
                      [readOnly]="true"
                      [style]="{ border: 'none' }"
                      [modules]="{ toolbar: false }"
                    >
                    </quill-editor>
                  </div>
                </div>
              </div>
            </div>

            <p-messages [(value)]="vehicleMsgs"></p-messages>

            <div styleClass="align-center ui-g-12">
              <form #searchByRegNumForm="ngForm">
                <div class="ui-g content-container-x" style="padding-left: 0px">
                  <div class="ui-g-12 content-container-row">
                    <div class="registrationNumberBox">
                      <input
                        type="text"
                        name="registrationNumber"
                        pInputText
                        [(ngModel)]="registrationNumber"
                        required
                        class="vehicleReg"
                        placeholder="Add Reg"
                      />
                    </div>

                    <button
                      pButton
                      (click)="SearchVehicle()"
                      icon="fa fa-search"
                      class="ui-button-success"
                      style="margin-left: 15px; vertical-align: super"
                      [disabled]="isSearchVehicle || !registrationNumber.length > 0"
                    ></button>
                  </div>

                  <div
                    class="ui-g-12 content-container-row"
                    *ngIf="vehicle && !isShowSaerchManual && !isShowVehicleDetail"
                  >
                    {{ vehicle.make }} {{ vehicle.model }} {{ vehicle.kerbWeight }} kg
                    {{ vehicle.registrationDate | date : 'yyyy' }}

                    <!--<a href="javascript:void(0)" (click)="ShowVehicleDetails()" style="text-decoration: underline; margin-left:10px">Edit Vehicle Details</a>-->
                  </div>

                  <div class="ui-g-12 content-container-row">
                    <button
                      pButton
                      label="Edit Vehicle"
                      (click)="ShowVehicleDetails()"
                      [disabled]="!(vehicle && !isShowSaerchManual && !isShowVehicleDetail)"
                      class="edit-vehicle-button"
                    ></button>

                    <button
                      pButton
                      label="No Registration"
                      (click)="NoRegistration()"
                      [disabled]="isSearchVehicle"
                    ></button>
                  </div>
                </div>

                <!--<div class="content-container">
                    <div class="reg" style="float:left;">
                        <input type="text" name="registrationNumber" pInputText
                                [(ngModel)]="registrationNumber" required
                                class="vehicleReg" placeholder="Add Reg" />
                    </div>
                </div>
                <button pButton (click)="SearchVehicle()" icon="fa ui-icon-search"
                        style="float: left; margin-left: 15px; margin-top: 12px; height: 35px; margin-right: 150px;"
                        [disabled]="isSearchVehicle || searchByRegNumForm.invalid"></button>

                <button pButton label="No Registration"
                        style="float: left; width:150px; margin-top: 12px; margin-left: 15px; height: 35px"
                        (click)="NoRegistration()" [disabled]="isSearchVehicle"></button>-->
              </form>
            </div>

            <div
              styleClass="align-center ui-g-12"
              *ngIf="vehicle && isTaxMotFound && !isShowSaerchManual && !isShowVehicleDetail"
            >
              <div class="ui-g content-container-row" style="padding-left: 0px">
                <div class="ui-g-6 content-container-row" style="text-align: right">
                  <div
                    class="motVat"
                    [class.motVatGreen]="isTaxValid"
                    [class.motVatRed]="!isTaxValid || vehicle.taxStatus.toLowerCase() == 'sorn'"
                  >
                    <div
                      *ngIf="vehicle.taxStatus.toLowerCase() == 'sorn'"
                      class="ui-g-12 motVatTitle"
                    >
                      SORN
                    </div>
                    <div
                      *ngIf="vehicle.taxStatus.toLowerCase() == 'taxed'"
                      class="ui-g-12 motVatTitle"
                    >
                      Taxed
                    </div>
                    <div
                      *ngIf="!isTaxValid && vehicle.taxStatus.toLowerCase() != 'sorn'"
                      class="ui-g-12 motVatTitle"
                    >
                      Not Taxed
                    </div>
                    <div
                      *ngIf="vehicle.taxStatus.toLowerCase() != 'sorn'"
                      class="ui-g-12"
                      style="margin-top: 12px"
                    >
                      Tax Due: {{ vehicle.taxDueDate | datex : 'DD MMMM YYYY' }}
                    </div>
                  </div>
                </div>

                <div class="ui-g-6 content-container-row" style="text-align: left">
                  <div
                    class="motVat"
                    [class.motVatGreen]="isMotValid || motNotRequired"
                    [class.motVatRed]="!isMotValid && !motNotRequired"
                  >
                    <div *ngIf="isMotValid || motNotRequired" class="ui-g-12 motVatTitle">MOT</div>
                    <div *ngIf="!isMotValid && !motNotRequired" class="ui-g-12 motVatTitle">
                      No MOT
                    </div>
                    <div *ngIf="vehicle.motExpiryDate" class="ui-g-12" style="margin-top: 12px">
                      MOT Due: {{ vehicle.motExpiryDate | datex : 'DD MMMM YYYY' }}
                    </div>
                    <div *ngIf="!vehicle.motExpiryDate" class="ui-g-12" style="margin-top: 12px">
                      No MOT due date
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              style="width: 100%; text-align: center"
              *ngIf="vehicle && !isTaxMotFound && !isShowSaerchManual && !isShowVehicleDetail"
            >
              <div class="ui-g content-container-row" style="padding-left: 0px">
                <div class="ui-g-12 content-container-row" style="font-size: large">
                  No MOT/TAX data found, please confirm that the vehicle will have the following for
                  the movement dates:
                </div>

                <div
                  class="ui-g-6 content-container-row"
                  style="text-align: right; padding-right: 20px"
                >
                  <p-checkbox
                    binary="true"
                    label="Valid TAX"
                    [(ngModel)]="isTaxValid"
                    (onChange)="onTaxChanged($event)"
                  ></p-checkbox>
                </div>

                <div
                  class="ui-g-6 content-container-row"
                  style="text-align: left; padding-left: 20px"
                >
                  <p-checkbox
                    binary="true"
                    label="Valid MOT"
                    [(ngModel)]="isMotValid"
                    (onChange)="onMotChanged($event)"
                  ></p-checkbox>
                </div>
              </div>
            </div>

            <div style="width: 100%; text-align: center" *ngIf="isShowSaerchByVin">
              <form #searchByVinForm="ngForm">
                <div class="ui-g content-container-x" style="padding-left: 0px">
                  <div class="ui-g-12 content-container-row">
                    <div class="md-inputfield" style="float: left; width: 260px; margin-top: 12px">
                      <input
                        type="text"
                        name="vinNumber"
                        pInputText
                        style="width: 260px"
                        [(ngModel)]="vin"
                        required
                      />
                      <label>VIN</label>
                    </div>

                    <button
                      pButton
                      icon="fa fa-search"
                      (click)="SearchVehicleByVin()"
                      style="margin-left: 15px; vertical-align: super"
                      [disabled]="isSearchVehicle || searchByVinForm.invalid"
                    ></button>
                  </div>

                  <div class="ui-g-12 content-container-row">
                    <button
                      pButton
                      label="No VIN"
                      (click)="NoVin()"
                      [disabled]="isSearchVehicle"
                    ></button>
                  </div>
                </div>
              </form>
            </div>

            <div class="header" *ngIf="isShowSaerchManual">
              <h3>Manual Entry</h3>
            </div>

            <div style="position: relative" class="ui-g">
              <div class="ui-g vehilce-panel" *ngIf="false">
                <div class="blue-box-container dashboard">
                  <div class="ui-g colorbox colorbox-2">
                    <div class="ui-g-2">
                      <i class="material-icons">directions_car</i>
                    </div>
                    <div class="ui-g-8">
                      <div style="padding-top: 5px; padding-bottom: 5px">
                        <span
                          class="colorbox-name"
                          style="margin-top: 0; margin-bottom: 0; height: 100%; line-height: normal"
                        >
                          {{ vehicle.make }} {{ vehicle.model }} <br />
                          {{ vehicle.kerbWeight }} kg {{ vehicle.registrationDate | date : 'yyyy' }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div style="margin-top: auto; margin-bottom: auto; float: left; margin-left: 15px">
                  <button
                    pButton
                    label="Edit Vehicle Details"
                    [disabled]="isShowVehicleDetail"
                    (click)="ShowVehicleDetails()"
                    style="width: 150px; height: 35px"
                  ></button>
                </div>
                <div style="clear: both"></div>
              </div>
              <div class="ui-g-12">
                <form novalidate #vehicleDetailForm="ngForm">
                  <div
                    class="ui-g vehilce-panel"
                    *ngIf="vehicle && (isShowVehicleDetail || isShowSaerchManual)"
                  >
                    <div class="ui-g-12">
                      <div class="ui-g-4">
                        <span
                          class="md-inputfield inputfield-border-container"
                          style="margin-right: 40%"
                        >
                          <input
                            type="text"
                            name="make"
                            pInputText
                            required
                            style="width: 100%"
                            [(ngModel)]="vehicle.make"
                            id="make"
                            maxlength="30"
                          />
                          <label>Make*</label>
                        </span>
                      </div>
                      <div class="ui-g-4">
                        <span
                          class="md-inputfield inputfield-border-container"
                          style="margin-right: 40%"
                        >
                          <input
                            type="text"
                            name="model"
                            pInputText
                            required
                            style="width: 100%"
                            [(ngModel)]="vehicle.model"
                            id="model"
                            maxlength="30"
                          />
                          <label>Model*</label>
                        </span>
                      </div>
                      <div class="ui-g-4">
                        <span
                          class="md-inputfield inputfield-border-container"
                          style="margin-right: 40%"
                        >
                          <input
                            type="number"
                            name="kerbWeight"
                            pInputText
                            required
                            style="width: 100%"
                            (keydown)="limitKerbWeight($event)"
                            (keyup)="limitKerbWeight($event)"
                            [(ngModel)]="vehicle.kerbWeight"
                            id="kerbWeight"
                            pattern="^(?:[0-9][0-9]{0,4}(?:\.\d{1,2})?|100000)$"
                            min="1"
                            max="100000"
                            [disabled]="isShowWeightEditor"
                          />
                          <label>Kerb Weight, kg*</label>
                        </span>
                      </div>
                    </div>

                    <div class="ui-g-12">
                      <div class="ui-g-4">
                        <span
                          class="md-inputfield inputfield-border-container"
                          style="margin-right: 40%"
                        >
                          <input
                            type="text"
                            name="registrationNumber"
                            pInputText
                            style="width: 100%"
                            [(ngModel)]="vehicle.registrationNumber"
                            id="registrationNumber"
                            maxlength="8"
                            required
                          />
                          <label>Reg Number*</label>
                        </span>
                      </div>
                      <div class="ui-g-4">
                        <span
                          class="md-inputfield inputfield-border-container"
                          style="margin-right: 40%"
                        >
                          <input
                            type="text"
                            name="color"
                            pInputText
                            style="width: 100%"
                            [(ngModel)]="vehicle.color"
                            id="color"
                            maxlength="20"
                          />
                          <label>Color</label>
                        </span>
                      </div>
                      <div class="ui-g-4">
                        <div
                          class="md-inputfield inputfield-border-container"
                          style="margin-right: 40%"
                        >
                          <p-dropdown
                            class="fuel-type-dropdown"
                            [ngModelOptions]="{ standalone: true }"
                            [(ngModel)]="vehicle.fuelType"
                            [options]="fuelTypes"
                            required
                          ></p-dropdown>
                          <label>Fuel Type*</label>
                        </div>
                      </div>
                    </div>
                    <div class="ui-g-12">
                      <div class="ui-g-4">
                        <span
                          class="md-inputfield inputfield-border-container"
                          style="margin-right: 40%"
                        >
                          <input
                            type="text"
                            name="body"
                            pInputText
                            style="width: 100%"
                            [(ngModel)]="vehicle.body"
                            id="body"
                            maxlength="30"
                          />
                          <label>Body</label>
                        </span>
                      </div>

                      <div class="ui-g-4">
                        <span
                          class="md-inputfield inputfield-border-container"
                          style="margin-right: 40%"
                        >
                          <input
                            type="text"
                            name="wheelbaseLength"
                            pInputText
                            style="width: 100%"
                            [(ngModel)]="vehicle.wheelbaseLength"
                            id="wheelbaseLength"
                            maxlength="30"
                          />
                          <label>Wheelbase Length</label>
                        </span>
                      </div>
                      <div class="ui-g-4">
                        <span
                          class="md-inputfield inputfield-border-container"
                          style="margin-right: 40%"
                        >
                          <input
                            type="number"
                            name="sizeEngine"
                            pInputText
                            style="width: 100%"
                            (keydown)="limitSizeEngine($event)"
                            (keyup)="limitSizeEngine($event)"
                            [(ngModel)]="vehicle.sizeEngine"
                            id="sizeEngin"
                            pattern="^(?:[0-9][0-9]{0,4}(?:\.\d{1,2})?|100000)$"
                            min="0"
                            max="100000"
                          />
                          <label>Size Engine, cc</label>
                        </span>
                      </div>
                    </div>
                    <div class="ui-g-12">
                      <div class="ui-g-4">
                        <span
                          class="md-inputfield inputfield-border-container"
                          style="margin-right: 40%"
                        >
                          <input
                            type="number"
                            name="height"
                            pInputText
                            style="width: 100%"
                            (keydown)="limitHeight($event)"
                            (keyup)="limitHeight($event)"
                            [(ngModel)]="vehicle.height"
                            id="height"
                            pattern="^(?:[0-9][0-9]{0,4}(?:\.\d{1,2})?|100000)$"
                            min="0"
                            max="100000"
                          />
                          <label>Height, mm</label>
                        </span>
                      </div>
                      <div class="ui-g-4">
                        <span
                          class="md-inputfield inputfield-border-container"
                          style="margin-right: 40%"
                        >
                          <input
                            type="number"
                            name="carLength"
                            pInputText
                            style="width: 100%"
                            (keydown)="limitCarLength($event)"
                            (keyup)="limitCarLength($event)"
                            [(ngModel)]="vehicle.carLength"
                            id="carLength"
                            pattern="^(?:[0-9][0-9]{0,4}(?:\.\d{1,2})?|100000)$"
                            min="0"
                            max="100000"
                          />
                          <label>Car Length, mm</label>
                        </span>
                      </div>
                      <div class="ui-g-4">
                        <span
                          class="md-inputfield inputfield-border-container"
                          style="margin-right: 40%"
                        >
                          <p-calendar
                            [(ngModel)]="vehicle.registrationDate"
                            name="registrationDate"
                            class="input-no-underline"
                            [showTime]="false"
                            dateFormat="d/m/yy"
                            id="registrationDate"
                          ></p-calendar>
                          <label>Registration Date</label>
                        </span>
                      </div>
                    </div>
                    <div class="ui-g-12">
                      <div class="ui-g-4">
                        <p-checkbox
                          name="isTaxValid"
                          binary="true"
                          label="Valid TAX for movement dates"
                          [(ngModel)]="isTaxValid"
                          (onChange)="onTaxChanged($event)"
                        ></p-checkbox>
                      </div>

                      <div class="ui-g-4">
                        <p-checkbox
                          name="isMotValid"
                          binary="true"
                          label="Valid MOT for movement dates"
                          [(ngModel)]="isMotValid"
                        ></p-checkbox>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              <div
                style="
                  width: 100%;
                  height: 100%;
                  position: absolute;
                  top: 0;
                  left: 0;
                  background: gray;
                  opacity: 0.3;
                "
                *ngIf="isSearchVehicle"
              >
                <img
                  src="assets/images/loader.gif"
                  style="margin-left: 45%; margin-top: 5%"
                  width="50"
                  height="50"
                  alt="load"
                />
              </div>
            </div>
          </div>

          <app-create-movement-department-team
            [taskInfo]="task"
            (departmentChangeEvent)="onDepartmentChangeEvent($event)"
            (teamChangeEvent)="onTeamChangeEvent($event)"
          ></app-create-movement-department-team>

          <div class="card" style="margin-bottom: 80px">
            <div
              *ngIf="
                !jobTypeIsAllowed(jobTypeEnum.Driven) &&
                !jobTypeIsAllowed(jobTypeEnum.Transported) &&
                !jobTypeIsAllowed(jobTypeEnum.Recovered) &&
                !jobTypeIsAllowed(jobTypeEnum.InspectAndCollect)
              "
              class="ui-g"
            >
              <div class="ui-g-12 please-select">
                <h2>Please contact Engineius team to set-up service options</h2>
              </div>
            </div>

            <div
              class="ui-g"
              *ngIf="
                (jobTypeIsAllowed(jobTypeEnum.Driven) && typeJob == 1) ||
                jobTypeIsAllowed(jobTypeEnum.InspectAndCollect)
              "
            >
              <div class="ui-g-12 please-select">
                <h2>Select Driven Option…</h2>
              </div>

              <div
                *ngIf="
                  taskTypeIsAllowed(taskTypeEnum.DrivenPlated) ||
                  taskTypeIsAllowed(taskTypeEnum.DrivenPlatedInspection)
                "
                class="ui-g-3 ui-lg-3 ui-md-4 ui-sm-12 job-type-container"
              >
                <div class="left-border"></div>
                <div class="ui-g">
                  <div class="ui-g-12">
                    <div class="ui-g-6">
                      <h2>Plated</h2>
                    </div>
                    <div class="ui-g-6">
                      <i
                        *ngIf="isPlated || isDrivenPlatedInspection"
                        class="vme-material-icons driven-type active-type"
                        >&#xe81c;</i
                      >
                      <i
                        *ngIf="!isPlated && !isDrivenPlatedInspection"
                        class="vme-material-icons driven-type"
                        >&#xe81c;</i
                      >
                      <!--<img *ngIf="isPlated" src="assets/images/driven_inactive.png" class="icon-right" width="77" height="76" />
                      <img *ngIf="isPlated" src="assets/images/driven_active.png" width="77" height="76" class="icon-right" />-->
                    </div>
                  </div>
                  <div class="ui-g-12 plated">
                    <p-toggleButton
                      [onLabel]="
                        taskTypeIsAllowed(taskTypeEnum.DrivenPlatedInspection)
                          ? 'Standard'
                          : 'Selected'
                      "
                      [offLabel]="
                        taskTypeIsAllowed(taskTypeEnum.DrivenPlatedInspection)
                          ? 'Standard'
                          : 'Select this option'
                      "
                      [(ngModel)]="isPlated"
                      [style]="{
                        width: taskTypeIsAllowed(taskTypeEnum.DrivenPlatedInspection)
                          ? '45%'
                          : '50%'
                      }"
                      [disabled]="!vehicle || isDebug || !isMotValid || isDrivenDisabled"
                      (onChange)="onTaskTypeChange($event, 1)"
                      *ngIf="taskTypeIsAllowed(taskTypeEnum.DrivenPlated)"
                      data-test-id="plated"
                    ></p-toggleButton>
                    <p-toggleButton
                      onLabel="Inspect & Collect"
                      offLabel="Inspect & Collect"
                      [(ngModel)]="isDrivenPlatedInspection"
                      [style]="{
                        width: taskTypeIsAllowed(taskTypeEnum.DrivenPlated) ? '45%' : '50%'
                      }"
                      [disabled]="!isTaxValid || !isMotValid"
                      (onChange)="onTaskTypeChange($event, 16)"
                      *ngIf="taskTypeIsAllowed(taskTypeEnum.DrivenPlatedInspection)"
                      data-test-id="driver-plated-inspection"
                    ></p-toggleButton>
                  </div>
                  <div
                    class="description-job-type"
                    [class.disable-description]="!isPlated && !isDrivenPlatedInspection"
                    *ngIf="taskTypeIsAllowed(taskTypeEnum.DrivenPlatedInspection)"
                    style="margin-bottom: 0 !important"
                  >
                    <div>Inspect & Collect includes:</div>
                    <div>
                      <i class="fa fa-check" aria-hidden="true"></i>30 Minute Detailed Inspection
                      and Engineer Call
                    </div>
                  </div>
                  <div
                    class="description-job-type"
                    [class.disable-description]="!isPlated && !isDrivenPlatedInspection"
                  >
                    <div>By selecting this option, you confirm that the vehicle is:</div>
                    <div><i class="fa fa-check" aria-hidden="true"></i>Road worthy</div>
                    <div><i class="fa fa-check" aria-hidden="true"></i>MOTed</div>
                    <div><i class="fa fa-check" aria-hidden="true"></i>Driveable</div>

                    <app-vehicle-kerb-weight-input
                      *ngIf="
                        (isPlated || isDrivenPlatedInspection) && vehicle && isShowWeightEditor
                      "
                      [isTransported]="false"
                      (onWeightChanged)="onVehicleWeightChanged($event)"
                    >
                    </app-vehicle-kerb-weight-input>
                  </div>
                </div>
              </div>

              <div
                *ngIf="taskTypeIsAllowed(taskTypeEnum.DrivenUninsured)"
                class="ui-g-3 ui-lg-3 ui-md-4 ui-sm-12 job-type-container"
              >
                <div class="left-border"></div>
                <div class="ui-g customer-insured">
                  <div class="ui-g-12">
                    <div class="ui-g-6">
                      <h2>Customer Insured</h2>
                    </div>
                    <div class="ui-g-6 job-type-icon">
                      <i
                        *ngIf="isCustomerInsured"
                        class="vme-material-icons driven-type insured active-type"
                        >&#xe81b;</i
                      >
                      <i *ngIf="!isCustomerInsured" class="vme-material-icons driven-type insured"
                        >&#xe81b;</i
                      >
                      <!--<img *ngIf="!isCustomerInsured" src="assets/images/driven_inactive.png" width="77" height="76" class="icon-right" />
                      <img *ngIf="isCustomerInsured" src="assets/images/driven_active.png" width="77" height="76" class="icon-right" />-->
                    </div>
                  </div>
                  <div class="ui-g-12">
                    <p-toggleButton
                      onLabel="Selected"
                      offLabel="Select this option"
                      [(ngModel)]="isCustomerInsured"
                      [style]="{ width: '50%' }"
                      [disabled]="!isTaxValid || isDebug"
                      (onChange)="onTaskTypeChange($event, 2)"
                      data-test-id="customer-insured"
                    ></p-toggleButton>
                  </div>
                  <div
                    class="description-job-type"
                    [class.disable-description]="!isCustomerInsured"
                  >
                    <div>By selecting this option, you confirm that the vehicle is:</div>
                    <div><i class="fa fa-check" aria-hidden="true"></i>Road worthy</div>
                    <div><i class="fa fa-check" aria-hidden="true"></i>MOTed</div>
                    <div><i class="fa fa-check" aria-hidden="true"></i>Driveable</div>
                    <div><i class="fa fa-check" aria-hidden="true"></i>Road Fund Licenced</div>
                    <div>
                      <i class="fa fa-check" aria-hidden="true"></i>Insured by the vehicle owner
                    </div>

                    <app-vehicle-kerb-weight-input
                      *ngIf="isCustomerInsured && vehicle && isShowWeightEditor"
                      [isTransported]="false"
                      (onWeightChanged)="onVehicleWeightChanged($event)"
                    >
                    </app-vehicle-kerb-weight-input>
                  </div>
                </div>
              </div>

              <div
                *ngIf="
                  taskTypeIsAllowed(taskTypeEnum.DriverInsured) ||
                  taskTypeIsAllowed(taskTypeEnum.DrivenInsuredInspection)
                "
                class="ui-g-3 ui-lg-3 ui-md-4 ui-sm-12 job-type-container"
              >
                <div class="left-border"></div>
                <div class="ui-g">
                  <div class="ui-g-12">
                    <div class="ui-g-6">
                      <h2>Driver Insured</h2>
                    </div>
                    <div class="ui-g-6 job-type-icon">
                      <i
                        *ngIf="isDriverInsured || isDrivenInsuredInspection"
                        class="vme-material-icons driven-type insured active-type"
                        >&#xe908;</i
                      >
                      <i
                        *ngIf="!isDriverInsured && !isDrivenInsuredInspection"
                        class="vme-material-icons driven-type insured"
                        >&#xe908;</i
                      >
                      <!--<img *ngIf="!isCustomerInsured" src="assets/images/driven_inactive.png" width="77" height="76" class="icon-right" />
                      <img *ngIf="isCustomerInsured" src="assets/images/driven_active.png" width="77" height="76" class="icon-right" />-->
                    </div>
                  </div>
                  <div class="ui-g-12">
                    <p-toggleButton
                      [onLabel]="
                        taskTypeIsAllowed(taskTypeEnum.DrivenPlatedInspection)
                          ? 'Standard'
                          : 'Selected'
                      "
                      [offLabel]="
                        taskTypeIsAllowed(taskTypeEnum.DrivenPlatedInspection)
                          ? 'Standard'
                          : 'Select this option'
                      "
                      [(ngModel)]="isDriverInsured"
                      [style]="{
                        width: taskTypeIsAllowed(taskTypeEnum.DrivenInsuredInspection)
                          ? '45%'
                          : '50%'
                      }"
                      [disabled]="!isTaxValid || !isMotValid || isDrivenDisabled"
                      (onChange)="onTaskTypeChange($event, 3)"
                      *ngIf="taskTypeIsAllowed(taskTypeEnum.DriverInsured)"
                      data-test-id="driver-insured"
                    ></p-toggleButton>
                    <p-toggleButton
                      onLabel="Inspect & Collect"
                      offLabel="Inspect & Collect"
                      [(ngModel)]="isDrivenInsuredInspection"
                      [style]="{
                        width: taskTypeIsAllowed(taskTypeEnum.DriverInsured) ? '45%' : '50%'
                      }"
                      [disabled]="!isTaxValid || !isMotValid"
                      (onChange)="onTaskTypeChange($event, 15)"
                      *ngIf="taskTypeIsAllowed(taskTypeEnum.DrivenInsuredInspection)"
                      data-test-id="driver-insured-inspection"
                    ></p-toggleButton>
                  </div>
                  <div
                    class="description-job-type"
                    [class.disable-description]="!isDriverInsured && !isDrivenInsuredInspection"
                    *ngIf="taskTypeIsAllowed(taskTypeEnum.DrivenInsuredInspection)"
                    style="margin-bottom: 0 !important"
                  >
                    <div>Inspect & Collect includes:</div>
                    <div>
                      <i class="fa fa-check" aria-hidden="true"></i>30 Minute Detailed Inspection
                      and Engineer Call
                    </div>
                  </div>
                  <div
                    class="description-job-type"
                    [class.disable-description]="!isDriverInsured && !isDrivenInsuredInspection"
                  >
                    <div>By selecting this option, you confirm that the vehicle is:</div>
                    <div><i class="fa fa-check" aria-hidden="true"></i>Road worthy</div>
                    <div><i class="fa fa-check" aria-hidden="true"></i>MOTed</div>
                    <div><i class="fa fa-check" aria-hidden="true"></i>Driveable</div>
                    <div><i class="fa fa-check" aria-hidden="true"></i>Road Fund Licenced</div>

                    <app-vehicle-kerb-weight-input
                      *ngIf="
                        (isDriverInsured || isDrivenInsuredInspection) &&
                        vehicle &&
                        isShowWeightEditor
                      "
                      [isTransported]="false"
                      (onWeightChanged)="onVehicleWeightChanged($event)"
                    >
                    </app-vehicle-kerb-weight-input>
                  </div>
                </div>
              </div>

              <div
                *ngIf="taskTypeIsAllowed(taskTypeEnum.DrivenPrestige)"
                class="ui-g-3 ui-lg-3 ui-md-4 ui-sm-12 job-type-container"
              >
                <div class="left-border"></div>
                <div class="ui-g">
                  <div class="ui-g-12">
                    <div class="ui-g-6">
                      <h2>Prestige Driven</h2>
                    </div>
                    <div class="ui-g-6 job-type-icon">
                      <i
                        *ngIf="isPrestige"
                        class="vme-material-icons driven-type insured active-type"
                        >&#xe90d;</i
                      >
                      <i *ngIf="!isPrestige" class="vme-material-icons driven-type insured"
                        >&#xe90d;</i
                      >
                      <!--<img *ngIf="!isCustomerInsured" src="assets/images/driven_inactive.png" width="77" height="76" class="icon-right" />
                      <img *ngIf="isCustomerInsured" src="assets/images/driven_active.png" width="77" height="76" class="icon-right" />-->
                    </div>
                  </div>
                  <div class="ui-g-12">
                    <p-toggleButton
                      onLabel="Selected"
                      offLabel="Select this option"
                      [(ngModel)]="isPrestige"
                      [style]="{ width: '50%' }"
                      [disabled]="!isTaxValid || isDebug || !isMotValid || isDrivenDisabled"
                      (onChange)="onTaskTypeChange($event, 5)"
                      data-test-id="prestige"
                    ></p-toggleButton>
                  </div>
                  <div class="description-job-type" [class.disable-description]="!isPrestige">
                    <div>By selecting this option, you confirm that the vehicle is:</div>
                    <div><i class="fa fa-check" aria-hidden="true"></i>Road worthy</div>
                    <div><i class="fa fa-check" aria-hidden="true"></i>MOTed</div>
                    <div><i class="fa fa-check" aria-hidden="true"></i>Driveable</div>
                    <div><i class="fa fa-check" aria-hidden="true"></i>Road Fund Licenced</div>

                    <app-vehicle-kerb-weight-input
                      *ngIf="isPrestige && vehicle && isShowWeightEditor"
                      [isTransported]="false"
                      (onWeightChanged)="onVehicleWeightChanged($event)"
                    >
                    </app-vehicle-kerb-weight-input>
                  </div>
                </div>
              </div>

              <div
                *ngIf="taskTypeIsAllowed(taskTypeEnum.DrivenEngineiusGo)"
                class="ui-g-3 ui-lg-3 ui-md-4 ui-sm-12 job-type-container"
              >
                <div class="left-border"></div>
                <div class="ui-g">
                  <div class="ui-g-12">
                    <div class="ui-g-6">
                      <h2>Engineius Go</h2>
                    </div>
                    <div class="ui-g-6 job-type-icon">
                      <i
                        [class.active-type]="isEngineiusGo"
                        class="vme-material-icons driven-type insured"
                        >&#xe91;</i
                      >
                    </div>
                  </div>
                  <div class="ui-g-12">
                    <p-toggleButton
                      onLabel="Selected"
                      offLabel="Select this option"
                      [(ngModel)]="isEngineiusGo"
                      [style]="{ width: '50%' }"
                      [disabled]="!isTaxValid || !isMotValid || isDrivenDisabled"
                      (onChange)="onTaskTypeChange($event, 9)"
                      data-test-id="engineius-go"
                    ></p-toggleButton>
                  </div>
                  <div class="description-job-type" [class.disable-description]="!isEngineiusGo">
                    <div>By selecting this option, you confirm that the vehicle is:</div>
                    <div><i class="fa fa-check" aria-hidden="true"></i>Road worthy</div>
                    <div><i class="fa fa-check" aria-hidden="true"></i>MOTed</div>
                    <div><i class="fa fa-check" aria-hidden="true"></i>Driveable</div>
                    <div><i class="fa fa-check" aria-hidden="true"></i>Road Fund Licenced</div>

                    <app-vehicle-kerb-weight-input
                      *ngIf="isEngineiusGo && vehicle && isShowWeightEditor"
                      [isTransported]="false"
                      (onWeightChanged)="onVehicleWeightChanged($event)"
                    >
                    </app-vehicle-kerb-weight-input>
                  </div>
                </div>
              </div>

              <div
                *ngIf="taskTypeIsAllowed(taskTypeEnum.DrivenTurnaround)"
                class="ui-g-3 ui-lg-3 ui-md-4 ui-sm-12 job-type-container"
              >
                <div class="left-border"></div>
                <div class="ui-g">
                  <div class="ui-g-12">
                    <div class="ui-g-6">
                      <h2>Turnaround</h2>
                    </div>
                    <div class="ui-g-6">
                      <img
                        *ngIf="!isTurnaround"
                        src="assets/images/turnaround_inactive.png"
                        class="icon-right"
                        width="77"
                        height="76"
                      />
                      <img
                        *ngIf="isTurnaround"
                        src="assets/images/turnaround_active.png"
                        width="77"
                        height="76"
                        class="icon-right"
                      />
                    </div>
                  </div>
                  <div class="ui-g-12">
                    <p-toggleButton
                      onLabel="Selected"
                      offLabel="Select this option"
                      [(ngModel)]="isTurnaround"
                      [style]="{ width: '50%' }"
                      [disabled]="!isTaxValid || !isMotValid || isDrivenDisabled"
                      (onChange)="onTaskTypeChange($event, 10)"
                      data-test-id="turnaround"
                    ></p-toggleButton>
                  </div>
                  <div class="description-job-type" [class.disable-description]="!isTurnaround">
                    <div>By selecting this option, you confirm that the vehicle is:</div>
                    <div><i class="fa fa-check" aria-hidden="true"></i>Road worthy</div>
                    <div><i class="fa fa-check" aria-hidden="true"></i>MOTed</div>
                    <div><i class="fa fa-check" aria-hidden="true"></i>Driveable</div>
                    <div><i class="fa fa-check" aria-hidden="true"></i>Road Fund Licenced</div>

                    <app-vehicle-kerb-weight-input
                      *ngIf="isTurnaround && vehicle && isShowWeightEditor"
                      [isTransported]="false"
                      (onWeightChanged)="onVehicleWeightChanged($event)"
                    >
                    </app-vehicle-kerb-weight-input>
                  </div>
                </div>
              </div>
            </div>

            <div class="ui-g" *ngIf="jobTypeIsAllowed(jobTypeEnum.Transported) && typeJob == 1">
              <div class="ui-g-12 please-select">
                <h2>Select Transported Option…</h2>
              </div>

              <div
                *ngIf="taskTypeIsAllowed(taskTypeEnum.UncoveredTransportedMovement)"
                class="ui-g-6 ui-lg-6 ui-md-4 ui-sm-12 job-type-container"
              >
                <div class="left-border"></div>
                <div class="ui-g">
                  <div class="ui-g-12">
                    <div class="ui-g-6">
                      <h2>Uncovered</h2>
                    </div>
                    <div class="ui-g-6">
                      <i *ngIf="isUncovered" class="vme-material-icons transported-type active-type"
                        >&#xe816;</i
                      >
                      <i *ngIf="!isUncovered" class="vme-material-icons transported-type"
                        >&#xe816;</i
                      >
                      <!--<img *ngIf="!isUncovered" src="assets/images/transported_inactive.png" width="149" height="65" class="icon-right" />
                      <img *ngIf="isUncovered" src="assets/images/transported_active.png" width="149" height="65" class="icon-right" />-->
                    </div>
                  </div>
                  <div class="ui-g-12">
                    <p-toggleButton
                      onLabel="Selected"
                      offLabel="Select this option"
                      [(ngModel)]="isUncovered"
                      [style]="{ width: '50%' }"
                      [disabled]="!vehicle || isDebug"
                      (onChange)="onTaskTypeChange($event, 6)"
                      data-test-id="uncovered"
                    ></p-toggleButton>
                  </div>
                  <div class="description-job-type" [class.disable-description]="!isUncovered">
                    <div>By selecting this option, you confirm that the vehicle is:</div>
                    <div><i class="fa fa-check" aria-hidden="true"></i>Fully accesible</div>
                    <div>
                      <i class="fa fa-check" aria-hidden="true"></i>Driveable (fully able to be
                      driven on to a transporter)
                    </div>

                    <app-vehicle-kerb-weight-input
                      *ngIf="isUncovered && vehicle && isShowWeightEditor"
                      [isTransported]="true"
                      (onWeightChanged)="onVehicleWeightChanged($event)"
                    >
                    </app-vehicle-kerb-weight-input>
                  </div>
                </div>
              </div>

              <div
                *ngIf="taskTypeIsAllowed(taskTypeEnum.CoveredTransportedMovement)"
                class="ui-g-6 ui-lg-6 ui-md-4 ui-sm-12 job-type-container"
              >
                <div class="left-border"></div>
                <div class="ui-g">
                  <div class="ui-g-12">
                    <div class="ui-g-6">
                      <h2>Covered</h2>
                    </div>
                    <div class="ui-g-6">
                      <i *ngIf="isCovered" class="vme-material-icons transported-type active-type"
                        >&#xe817;</i
                      >
                      <i *ngIf="!isCovered" class="vme-material-icons transported-type">&#xe817;</i>
                      <!--<img *ngIf="!isCovered" src="assets/images/transported_inactive.png" width="149" height="65" class="icon-right" />
                      <img *ngIf="isCovered" src="assets/images/transported_active.png" width="149" height="65" class="icon-right" />-->
                    </div>
                  </div>
                  <div class="ui-g-12">
                    <p-toggleButton
                      onLabel="Selected"
                      offLabel="Select this option"
                      [(ngModel)]="isCovered"
                      [style]="{ width: '50%' }"
                      [disabled]="!vehicle || isDebug"
                      (onChange)="onTaskTypeChange($event, 7)"
                      data-test-id="covered"
                    ></p-toggleButton>
                  </div>
                  <div class="description-job-type" [class.disable-description]="!isCovered">
                    <div>By selecting this option, you confirm that the vehicle is:</div>
                    <div><i class="fa fa-check" aria-hidden="true"></i>Fully accesible</div>
                    <div>
                      <i class="fa fa-check" aria-hidden="true"></i>Driveable (fully able to be
                      driven on to a transporter)
                    </div>

                    <app-vehicle-kerb-weight-input
                      *ngIf="isCovered && vehicle && isShowWeightEditor"
                      [isTransported]="true"
                      (onWeightChanged)="onVehicleWeightChanged($event)"
                    >
                    </app-vehicle-kerb-weight-input>
                  </div>
                </div>
              </div>
              <div
                *ngIf="taskTypeIsAllowed(taskTypeEnum.PrestigeTransported)"
                class="ui-g-6 ui-lg-6 ui-md-4 ui-sm-12 job-type-container"
              >
                <div class="left-border"></div>
                <div class="ui-g">
                  <div class="ui-g-12">
                    <div class="ui-g-6">
                      <h2>Prestige Transported</h2>
                    </div>
                    <div class="ui-g-6">
                      <img
                        *ngIf="!isPrestigeTransported"
                        src="assets/images/svg/transported_prestige.svg"
                        class="icon-right prestige-transported-type"
                      />
                      <img
                        *ngIf="isPrestigeTransported"
                        src="assets/images/svg/active_transported_prestige.svg"
                        class="icon-right prestige-transported-type"
                      />
                    </div>
                  </div>
                  <div class="ui-g-12">
                    <p-toggleButton
                      onLabel="Selected"
                      offLabel="Select this option"
                      [(ngModel)]="isPrestigeTransported"
                      [style]="{ width: '50%' }"
                      [disabled]="!vehicle || isDebug"
                      (onChange)="onTaskTypeChange($event, 17)"
                      data-test-id="covered"
                    ></p-toggleButton>
                  </div>
                  <div
                    class="description-job-type"
                    [class.disable-description]="!isPrestigeTransported"
                  >
                    <div>By selecting this option, you confirm that the vehicle is:</div>
                    <div><i class="fa fa-check" aria-hidden="true"></i>Fully accesible</div>
                    <div>
                      <i class="fa fa-check" aria-hidden="true"></i>Driveable (fully able to be
                      driven on to a transporter)
                    </div>

                    <app-vehicle-kerb-weight-input
                      *ngIf="isPrestigeTransported && vehicle && isShowWeightEditor"
                      [isTransported]="true"
                      (onWeightChanged)="onVehicleWeightChanged($event)"
                    >
                    </app-vehicle-kerb-weight-input>
                  </div>
                </div>
              </div>
            </div>

            <div class="ui-g" *ngIf="jobTypeIsAllowed(jobTypeEnum.Recovered) && typeJob == 1">
              <div class="ui-g-12 please-select">
                <h2>Select Recovery Option…</h2>
              </div>

              <div
                *ngIf="taskTypeIsAllowed(taskTypeEnum.RecoveredSkates)"
                class="ui-g-4 ui-lg-4 ui-md-4 ui-sm-12 job-type-container"
              >
                <div class="left-border"></div>
                <div class="ui-g">
                  <div class="ui-g-12" style="height: 70px">
                    <div class="ui-g-6">
                      <h2>Skates Only</h2>
                    </div>
                    <div class="ui-g-6">
                      <i *ngIf="isSkatesOnly" class="vme-material-icons recovery-type active-type"
                        >&#xe80d;</i
                      >
                      <i *ngIf="!isSkatesOnly" class="vme-material-icons recovery-type">&#xe80d;</i>
                    </div>
                  </div>
                  <div class="ui-g-12">
                    <p-toggleButton
                      onLabel="Selected"
                      offLabel="Select this option"
                      [(ngModel)]="isSkatesOnly"
                      [style]="{ width: '50%' }"
                      data-test-id="skates-only"
                    ></p-toggleButton>
                  </div>
                  <div class="description-job-type" [class.disable-description]="!isSkatesOnly">
                    <div>Generally for vehicles that are:</div>
                    <div><i class="fa fa-check" aria-hidden="true"></i>Not rollable</div>
                    <div><i class="fa fa-check" aria-hidden="true"></i>Not driveable</div>

                    <app-vehicle-kerb-weight-input
                      *ngIf="isSkatesOnly && vehicle && isShowWeightEditor"
                      [isTransported]="true"
                      (onWeightChanged)="onVehicleWeightChanged($event)"
                    >
                    </app-vehicle-kerb-weight-input>
                  </div>
                </div>
              </div>

              <div
                *ngIf="taskTypeIsAllowed(taskTypeEnum.RecoveryStandard)"
                class="ui-g-4 ui-lg-4 ui-md-4 ui-sm-12 job-type-container"
              >
                <div class="left-border"></div>
                <div class="ui-g">
                  <div class="ui-g-12" style="height: 70px">
                    <div class="ui-g-6">
                      <h2>Standard Recovery</h2>
                    </div>
                    <div class="ui-g-6">
                      <i
                        *ngIf="isRecoveryStandard"
                        class="vme-material-icons recovery-type active-type"
                        >&#xe811;</i
                      >
                      <i *ngIf="!isRecoveryStandard" class="vme-material-icons recovery-type"
                        >&#xe811;</i
                      >
                      <!--<img *ngIf="!isFullLiftOnly" src="assets/images/recovery_inactive.png" width="105" height="52" class="icon-right" />
                      <img *ngIf="isFullLiftOnly" src="assets/images/recovery_active.png" width="105" height="52" class="icon-right" />-->
                    </div>
                  </div>
                  <div class="ui-g-12">
                    <p-toggleButton
                      onLabel="Selected"
                      offLabel="Select this option"
                      [(ngModel)]="isRecoveryStandard"
                      [style]="{ width: '50%' }"
                      [disabled]="!vehicle || isDebug"
                      (onChange)="onTaskTypeChange($event, 11)"
                      data-test-id="standard-recovery"
                    ></p-toggleButton>
                  </div>
                  <div
                    class="description-job-type"
                    [class.disable-description]="!isRecoveryStandard"
                  >
                    <div>Generally for vehicles that are:</div>
                    <div>
                      <i class="fa fa-check" aria-hidden="true"></i>Rollable but needs winching +
                      towing eye is accessible (minor damage OK)
                    </div>
                    <div>
                      <i class="fa fa-check" aria-hidden="true"></i>Accessible for a recovery
                      vehicle without going off the paved highway
                    </div>

                    <app-vehicle-kerb-weight-input
                      *ngIf="isRecoveryStandard && vehicle && isShowWeightEditor"
                      [isTransported]="true"
                      (onWeightChanged)="onVehicleWeightChanged($event)"
                    >
                    </app-vehicle-kerb-weight-input>
                  </div>
                </div>
              </div>

              <div
                *ngIf="taskTypeIsAllowed(taskTypeEnum.RecoveredMoreEquipmentNeeded)"
                class="ui-g-4 ui-lg-4 ui-md-4 ui-sm-12 job-type-container"
              >
                <div class="left-border"></div>
                <div class="ui-g">
                  <div class="ui-g-12" style="height: 70px">
                    <div class="ui-g-6">
                      <h2>Complex Recovery</h2>
                    </div>
                    <div class="ui-g-6">
                      <i
                        *ngIf="isMoreEquipmentNeeded"
                        class="vme-material-icons recovery-type active-type"
                        >&#xe80c;</i
                      >
                      <i *ngIf="!isMoreEquipmentNeeded" class="vme-material-icons recovery-type"
                        >&#xe80c;</i
                      >
                      <!--<img *ngIf="!isMoreEquipmentNeeded" src="assets/images/recovery_inactive.png" width="105" height="52" class="icon-right" />
                      <img *ngIf="isMoreEquipmentNeeded" src="assets/images/recovery_active.png" width="105" height="52" class="icon-right" />-->
                    </div>
                  </div>
                  <div class="ui-g-12">
                    <p-toggleButton
                      onLabel="Selected"
                      offLabel="Select this option"
                      [(ngModel)]="isMoreEquipmentNeeded"
                      [disabled]="!vehicle || isDebug"
                      [style]="{ width: '50%' }"
                      data-test-id="more-equipment-needed"
                    ></p-toggleButton>
                  </div>
                  <div
                    class="description-job-type"
                    [class.disable-description]="!isMoreEquipmentNeeded"
                  >
                    <div>Generally for vehicles that:</div>
                    <div>
                      <div><i class="fa fa-check" aria-hidden="true"></i>Had a major accident</div>
                      <div><i class="fa fa-check" aria-hidden="true"></i>Are Missing Wheels</div>
                      <div><i class="fa fa-check" aria-hidden="true"></i>Require Full Lift</div>
                      <div>
                        <i class="fa fa-check" aria-hidden="true"></i>Have handbrake locked on
                      </div>
                      <div><i class="fa fa-check" aria-hidden="true"></i>Have seized brakes</div>
                      <div>
                        <i class="fa fa-check" aria-hidden="true"></i>Are at off-road location
                      </div>
                    </div>

                    <app-vehicle-kerb-weight-input
                      *ngIf="isMoreEquipmentNeeded && vehicle && isShowWeightEditor"
                      [isTransported]="true"
                      (onWeightChanged)="onVehicleWeightChanged($event)"
                    >
                    </app-vehicle-kerb-weight-input>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="ui-g"
              *ngIf="jobTypeIsAllowed(jobTypeEnum.Inspection) && (typeJob == 1 || typeJob == 14)"
            >
              <div class="ui-g-12 please-select">
                <h2>Select Inspection Option…</h2>
              </div>

              <div
                *ngIf="taskTypeIsAllowed(taskTypeEnum.Inspection)"
                class="ui-g-6 ui-lg-6 ui-md-4 ui-sm-12 job-type-container"
              >
                <div class="left-border"></div>
                <div class="ui-g">
                  <div class="ui-g-12">
                    <div class="ui-g-6">
                      <h2>Inspection</h2>
                    </div>
                    <div class="ui-g-6">
                      <div class="inspection-icon" [class.active-type]="isInspection"></div>
                    </div>
                  </div>
                  <div class="ui-g-12">
                    <p-toggleButton
                      onLabel="Selected"
                      offLabel="Select this option"
                      [(ngModel)]="isInspection"
                      [style]="{ width: '50%' }"
                      [disabled]="!vehicle || isDebug"
                      (onChange)="onTaskTypeChange($event, motWarningTypeEnum.Inspection)"
                      data-test-id="uncovered"
                    ></p-toggleButton>
                  </div>
                  <div class="description-job-type" [class.disable-description]="!isInspection">
                    <div>By selecting this option, you confirm that the vehicle is:</div>
                    <div><i class="fa fa-check" aria-hidden="true"></i>Fully accesible</div>
                    <div>
                      <i class="fa fa-check" aria-hidden="true"></i>Driveable (fully able to be
                      driven on to a transporter)
                    </div>

                    <app-vehicle-kerb-weight-input
                      *ngIf="isInspection && vehicle && isShowWeightEditor"
                      [isTransported]="true"
                      (onWeightChanged)="onVehicleWeightChanged($event)"
                    >
                    </app-vehicle-kerb-weight-input>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!--Step 4 (Review)-->
        <div *ngIf="activeStepIndex == 2" class="ui-g step-panel">
          <div class="ui-g-12" *ngIf="task != null">
            <task-control [taskInfo]="task" [isJobTaggingEnforced]="isJobTaggingEnforced">
            </task-control>
          </div>
        </div>
      </div>
    </div>
    <div class="ui-g-12" *ngIf="createMovementJobStep == 1" style="position: relative">
      <div
        *ngIf="
          draggedTask &&
          isCreateCustomJob == true &&
          draggedFromJob &&
          draggedFromJob.tasks.length > 1
        "
        class="new-job-container"
      >
        <div style="position: relative; padding: 5px; width: 150px">
          <div style="position: absolute; padding-left: 20px">
            <div class="new-job-header" style="width: 100px; min-height: 34px">
              <span> New Job </span>
            </div>
          </div>
          <div
            style="
              margin-top: 20px;
              border: 1px solid grey;
              border-radius: 5px;
              height: 250px;
              background: #f1f1f1;
            "
            [ngClass]="{ 'drop-place-highlight': draggedTask && isCreateCustomJob == true }"
            pDroppable="tasks"
            (onDrop)="dropNewJob($event)"
          >
            <div
              style="
                height: 60px;
                width: 60px;
                position: relative;
                margin-top: 20px;
                margin-left: 40px;
              "
            >
              <div
                style="
                  position: absolute;
                  width: 0px;
                  border: 1px solid black;
                  margin-left: 30px;
                  height: 100%;
                "
              ></div>
              <div
                style="
                  position: absolute;
                  height: 0px;
                  border: 1px solid black;
                  margin-top: 30px;
                  width: 100%;
                "
              ></div>
            </div>
            <div style="margin-top: 20px; padding: 5px">
              <span> Drop Vehicle here to create a new job </span>
            </div>
          </div>
        </div>
      </div>

      <div class="ui-g card" style="margin-bottom: 70px">
        <h1>Order List</h1>

        <div class="ui-g-12 task-sequence-reminder-text">
          <p>
            Ensure the sequence of tasks for each order to guarantee that drivers adhere to it
            accurately.
          </p>
        </div>

        <div class="ui-g-12">
          <p-selectButton
            [options]="newJobsSelectItems"
            [(ngModel)]="selectedNewJob"
          ></p-selectButton>
        </div>

        <div
          class="ui-g-12"
          *ngIf="orderSummarySelectedTask && ValidateTask(orderSummarySelectedTask).length > 0"
        >
          <div class="ui-message ui-messages-error ui-corner-all">
            <p>One or more dates are in the past or are invalid, please edit the task</p>
          </div>
        </div>

        <div
          class="ui-g-12"
          *ngIf="orderSummarySelectedTask && ValidateTaxMot(orderSummarySelectedTask).length > 0"
        >
          <div class="ui-message ui-messages-error ui-corner-all">
            <p>One or more dates are after TAX or MOT expiry date, please edit the task</p>
          </div>
        </div>

        <div class="ui-g-12">
          <job-details
            [job]="selectedNewJob"
            (selectedTaskChange)="orderSummarySelectTask($event)"
            [hideEditLocation]="true"
            [hideTaskSchedule]="true"
            (taskSequenceUpdated)="taskSequenceUpdated($event)"
            #jobDetailsView
          ></job-details>
        </div>

        <div class="ui-g-12" style="margin-top: 20px">
          <button
            pButton
            label="New Task"
            style="width: 120px; float: left"
            (click)="createNewTask()"
            icon="fa ui-icon-add"
          ></button>
          <button
            pButton
            label="Edit Task"
            style="width: 120px; float: left; margin-left: 4px"
            (click)="edit(orderSummarySelectedTask)"
            icon="fa ui-icon-edit"
            [disabled]="!orderSummarySelectedTask"
          ></button>
          <button
            pButton
            label="Delete Task"
            style="width: 120px; float: left; margin-left: 4px"
            (click)="Delete(selectedNewJob, orderSummarySelectedTask)"
            icon="fa ui-icon-close"
            class="ui-button-danger"
            [disabled]="!orderSummarySelectedTask"
          ></button>

          <button
            pButton
            label="Calculate Price"
            class="ui-button-success btn-to-right"
            (click)="CalculatePrice()"
            [disabled]="!AllOrderValid() || !AllTaxMotValid() || IsBusy"
          ></button>
        </div>
      </div>
    </div>
    <div class="ui-g-12" *ngIf="createMovementJobStep == 2">
      <div style="height: 70px" class="card">
        <button
          pButton
          label="Back"
          style="width: 120px; float: left"
          (click)="OpenJobPreview()"
          class="ui-button-success"
        ></button>

        <button
          pButton
          label="Save"
          style="width: 120px; float: right"
          (click)="SaveAllJob()"
          class="ui-button-success"
        ></button>
      </div>

      <div>
        <p-dataView [value]="newJobs" [style]="{ 'margin-top': '20px' }">
          <ng-template let-job let-i="index" pTemplate="item">
            <p-panel class="task-card-container" [style]="{ margin: '3px' }">
              <p-header>
                <div class="job-number">Job {{ i + 1 }}</div>
              </p-header>
              <div
                *ngIf="job.tasks.length == 1 || isTaskEquals(job.tasks)"
                class="task-card"
                style="padding-left: 10px; padding-top: 5px; padding-right: 10px"
              >
                <div style="margin-right: 300px; height: 650px; min-width: 300px">
                  <div style="float: left; width: 100%; border: 1px solid black">
                    <map-control
                      [origin]="job.tasks[0].pickupLocation"
                      [destination]="job.tasks[0].dropoffLocation"
                      [readOnly]="true"
                      [earliestPickup]="pickupEarliestDateTime"
                      [customStyle]="{ height: '650px' }"
                    ></map-control>
                  </div>
                  <div style="float: right; width: 300px; margin-right: -300px">
                    <display-route
                      [pickupEarliestDateTime]="job.tasks[0].pickupEarliestDateTime"
                      [pickupLocation]="job.tasks[0].pickupLocation"
                      [pickupLatestDateTime]="job.tasks[0].pickupLatestDateTime"
                      [dropoffEarliestDateTime]="job.tasks[0].dropoffEarliestDateTime"
                      [dropoffLocation]="job.tasks[0].dropoffLocation"
                      [dropoffLatestDateTime]="job.tasks[0].dropoffLatestDateTime"
                      [selectedTask]="job.tasks[0]"
                      [height]="650"
                      [taskTypeId]="job.tasks[0].taskTypeId"
                    >
                    </display-route>
                  </div>
                  <div style="clear: both"></div>
                </div>
              </div>
              <p-dataView
                [value]="job.tasks"
                pDroppable="tasks"
                [class.equals-task-container]="isTaskEquals(job.tasks)"
              >
                <ng-template let-task pTemplate="item">
                  <div class="task-card" [class.equals-task]="isTaskEquals(job.tasks)">
                    <div style="margin: 3px">
                      <div
                        [class.top-card-padding]="job.tasks.length == 1"
                        class="task-card-content"
                      >
                        <div
                          style="margin-right: 300px; height: 650px; min-width: 300px"
                          *ngIf="job.tasks.length > 1 && !isTaskEquals(job.tasks)"
                        >
                          <div style="float: left; width: 100%; border: 1px solid black">
                            <map-control
                              [origin]="task.pickupLocation"
                              [destination]="task.dropoffLocation"
                              [readOnly]="true"
                              [earliestPickup]="pickupEarliestDateTime"
                              [customStyle]="{ height: '650px' }"
                            ></map-control>
                          </div>
                          <div style="float: right; width: 300px; margin-right: -300px">
                            <display-route
                              [pickupEarliestDateTime]="task.pickupEarliestDateTime"
                              [pickupLocation]="task.pickupLocation"
                              [pickupLatestDateTime]="task.pickupLatestDateTime"
                              [dropoffEarliestDateTime]="task.dropoffEarliestDateTime"
                              [dropoffLocation]="task.dropoffLocation"
                              [dropoffLatestDateTime]="task.dropoffLatestDateTime"
                              [height]="650"
                              [selectedTask]="task"
                              [taskTypeId]="task.taskTypeId"
                            >
                            </display-route>
                          </div>
                          <div style="clear: both"></div>
                        </div>
                        <div class="vehicle-detail" *ngIf="task.vehicle">
                          <div
                            class="reg"
                            style="
                              width: 250px;
                              text-align: center;
                              padding-left: 10px;
                              display: inline-block;
                            "
                          >
                            <div style="line-height: 30px; font-size: 18px; float: left">
                              {{ task.vehicle.registrationNumber }}
                            </div>
                            <div class="strip"></div>
                            <div class="strip" style="margin-right: 5px"></div>
                            <div class="strip" style="margin-right: 5px"></div>
                            <div style="clear: both"></div>
                          </div>
                          <div>{{ task.vehicle.make }} {{ task.vehicle.model }}</div>
                          <div>
                            Weight: {{ task.vehicle.kerbWeight }} kg
                            {{ task.vehicle.registrationDate | date : 'yyyy' }}
                          </div>
                          <div style="width: 220px">
                            <a
                              style="color: #3b5169; cursor: pointer; text-decoration: underline"
                              (click)="
                                ShowDetailsForSelectVehicle($event, task.vehicle, vehicleDetailOp)
                              "
                            >
                              More details
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </p-dataView>
              <div>
                <select-supplier [job]="job"></select-supplier>
              </div>
            </p-panel>
          </ng-template>
        </p-dataView>
      </div>
    </div>
    <div
      style="
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background: gray;
        opacity: 0.3;
      "
      *ngIf="IsBusy"
    >
      <img
        src="assets/images/loader.gif"
        style="margin-left: 45%; margin-top: 20%; width: 50px; height: 50px"
        alt="load"
      />
    </div>
  </div>

  <div class="ui-g-12 fixed-button-bar">
    <div class="pull-right nav-btn-ctrl ui-lg-offset-4 ui-lg-8 ui-md-8 ui-md-offset-4 ui-sm-12">
      <button
        pButton
        label="Next"
        icon="fa ui-icon-navigate-next"
        iconPos="right"
        (click)="CalculatePrice()"
        *ngIf="isPriceButtonDisplay() && activeStepIndex == createTaskSteps.length - 2"
        [disabled]="!AllOrderValid() || IsBusy"
        class="ui-col-2 ui-sm-5 mt-1 btn-ctrl pull-right"
      ></button>

      <button
        pButton
        class="next-btn ui-col-2 ui-sm-5 mt-1 btn-ctrl"
        label="Next"
        [icon]="checkingDuplicates ? 'fa fa-spin fa-spinner' : 'fa ui-icon-navigate-next'"
        iconPos="right"
        (click)="checkForDuplicatesBeforeProceeding()"
        *ngIf="activeStepIndex != createTaskSteps.length - 2"
        [disabled]="
          (activeStepIndex >= 0 && !ValidateStep(activeStepIndex)) || checkingDuplicates || IsBusy
        "
      ></button>

      <button
        pButton
        class="next-btn ui-col-2 ui-sm-5 mt-1 btn-ctrl"
        label="Back"
        (click)="BackStep()"
        [disabled]="(activeStepIndex == 0 && !isCopy) || IsBusy"
        *ngIf="createMovementJobStep != 1"
      ></button>

      <button
        pButton
        label="Review Order(s)"
        (click)="ReviewOrders()"
        *ngIf="
          createMovementJobStep != 1 &&
          !isPriceButtonDisplay() &&
          activeStepIndex == createTaskSteps.length - 2
        "
        [disabled]="ValidateTask(task).length != 0 || IsBusy || !AllOrderValid()"
        class="ui-button-success ui-col-2 ui-sm-5 mt-1 btn-ctrl"
      ></button>

      <div
        style="position: relative"
        class="ui-sm-12 ui-g-2 ui-sm-5 mt-1 btn-ctrl"
        *ngIf="createMovementJobStep != 1 && activeStepIndex == createTaskSteps.length - 2"
      >
        <div class="more-option-btn-container">
          <button
            pButton
            label="Add Vehicle"
            (click)="CreateAddVehicleTask()"
            [disabled]="!AllOrderValid() || IsBusy"
            class="cyan-btn fixed-btn first-fixed-btn"
            title="Add another vehicle to be moved between the same locations at the same time"
          ></button>

          <button
            pButton
            label="Return Journey"
            (click)="CreateReturnJourneyTask()"
            [disabled]="!AllOrderValid() || IsBusy"
            class="cyan-btn fixed-btn second-fixed-btn"
            title="Book the same vehicle on the reverse route of that you have just entered, at a later date.{{
              isRoyalMail ? ' eg vehicle to go back to depot after maintenance.' : ''
            }}"
          ></button>
          <button
            pButton
            label="Follow on Journey"
            (click)="CreateFollowOnJourneyTask()"
            [disabled]="!AllOrderValid() || IsBusy"
            class="cyan-btn fixed-btn third-fixed-btn"
            title="Book same or different vehicle to return immediately on the reverse route of that you have just entered.{{
              isRoyalMail
                ? ' eg pool vehicle for driver to pick up and take back to depot or workshop.'
                : ''
            }}"
          ></button>
          <button
            pButton
            label="Create Another"
            (click)="CreateAnotherTask()"
            [disabled]="!AllOrderValid() || IsBusy"
            class="cyan-btn fixed-btn fourth-fixed-btn"
            title="Add another vehicle movement"
          ></button>
        </div>
        <button
          pButton
          label="More Options"
          style="opacity: 1"
          [disabled]="true"
          class="cyan-btn ui-g-12 ui-sm-12"
        ></button>
      </div>
      <button
        pButton
        label="Cancel"
        class="ui-col-2 ui-sm-5 mt-1 btn-ctrl ui-button-secondary"
        (click)="CancelCreateTask()"
        *ngIf="createMovementJobStep != 1 && isCanCancel(activeStepIndex)"
        [disabled]="IsBusy"
      ></button>
    </div>
  </div>
</div>
<!--EOF Page Content-->

<!--Vehicle Detail-->
<p-overlayPanel class="vehicle-detail-op" #vehicleDetailOp [showCloseIcon]="true">
  <div>Vehicle Details</div>
  <div class="ui-g vehicleDetails-content" *ngIf="selectVehicle">
    <div class="ui-g-12">
      <div class="ui-g-12">
        <div class="ui-g-3 header">Make:</div>
        <div class="ui-g-3 value">
          {{ selectVehicle.make }}
        </div>
        <div class="ui-g-3 header">Model:</div>
        <div class="ui-g-3 value">
          {{ selectVehicle.model }}
        </div>
      </div>
      <div class="ui-g-12">
        <div class="ui-g-3 header">Weight:</div>
        <div class="ui-g-3 value">
          {{ selectVehicle.kerbWeight }}
        </div>
        <div class="ui-g-3 header">Car Length:</div>
        <div class="ui-g-3 value">
          {{ selectVehicle.carLength }}
        </div>
      </div>
      <div class="ui-g-12">
        <div class="ui-g-3 header">Car Length:</div>
        <div class="ui-g-3 value">
          {{ selectVehicle.carLength }}
        </div>
        <div class="ui-g-3 header">Color:</div>
        <div class="ui-g-3 value">
          {{ selectVehicle.color }}
        </div>
      </div>
      <div class="ui-g-12">
        <div class="ui-g-3 header">Width:</div>
        <div class="ui-g-3 value">
          {{ selectVehicle.width }}
        </div>
        <div class="ui-g-3 header">Height:</div>
        <div class="ui-g-3 value">
          {{ selectVehicle.height }}
        </div>
      </div>
      <div class="ui-g-12">
        <div class="ui-g-3 header">Size Engine:</div>
        <div class="ui-g-3 value">
          {{ selectVehicle.sizeEngine }}
        </div>
        <div class="ui-g-3 header">Number Of Axles:</div>
        <div class="ui-g-3 value">
          {{ selectVehicle.numberOfAxles }}
        </div>
      </div>
      <div class="ui-g-12">
        <div class="ui-g-3 header">Body:</div>
        <div class="ui-g-3 value">
          {{ selectVehicle.body }}
        </div>
        <div class="ui-g-3 header">Wheelbase Length:</div>
        <div class="ui-g-3 value">
          {{ selectVehicle.wheelbaseLength }}
        </div>
      </div>
      <div class="ui-g-12">
        <div class="ui-g-3 header">Registration Date:</div>
        <div class="ui-g-3 value">
          {{ selectVehicle.registrationDate | date : 'dd/MM/yyyy' }}
        </div>
      </div>
    </div>
  </div>
</p-overlayPanel>
<!--EOF Vehicle Detail-->

<!--Delete Task-->
<p-dialog
  header="Delete Task"
  [(visible)]="showDeleteTaskDialog"
  modal="modal"
  [style]="{ width: '300px' }"
  [responsive]="true"
>
  <div class="ui-g">
    <div class="ui-g-12">
      <p>Please confirm task deletion</p>
    </div>
    <div class="ui-g-12">
      <button
        type="button"
        pButton
        icon="fa fa-close"
        (click)="cancelDeleteTask()"
        label="Cancel"
        class="ui-button btn-to-right"
      ></button>
      <button
        type="button"
        pButton
        icon="fa fa-check"
        (click)="acceptDeleteTask()"
        label="Ok"
        class="ui-button btn-to-right green-btn"
      ></button>
    </div>
  </div>

  <!--<p-footer>
      <button type="button" pButton icon="fa ui-icon-check" (click)="acceptDeleteTask()" label="Ok" class="btn-to-right green-btn"></button>
      <button type="button" pButton icon="fa ui-icon-close" (click)="cancelDeleteTask()" label="Cancel" class=""></button>
  </p-footer>-->
</p-dialog>
<!--EOF Delete Task-->

<!--Order Pricing Dialog-->
<p-dialog
  class="order-price-dialog"
  [header]="orderPriceDialogHeader"
  [(visible)]="displayCalculatePrice"
  [closeOnEscape]="false"
  modal="modal"
  (onHide)="CancelSubmitOrders()"
  [responsive]="true"
  [style]="{ width: '800px' }"
>
  <div>
    <div class="ui-g-12" style="text-align: center" *ngIf="!hasCustomerBookingRole">
      <ul style="padding-left: 10px">
        <li
          style="margin-bottom: 5px; list-style: none"
          *ngFor="let order of newJobs; let i = index"
        >
          <div style="text-align: left">
            <span style="font-size: 20px">
              <span style="font-weight: bold">
                <span
                  *ngIf="
                    newJobs[0]?.tasks[0]?.taskTypeId == 15 || newJobs[0]?.tasks[0]?.taskTypeId == 16
                  "
                  >Movement:
                </span>
                {{ getShortAddress(order.tasks[0].pickupLocation) }}
                <span *ngIf="order.tasks.length > 1">(+{{ order.tasks.length - 1 }})</span>
                <span> - </span>
                {{ getShortAddress(order.tasks[0].dropoffLocation) }}
                <span *ngIf="order.tasks.length > 1">(+{{ order.tasks.length - 1 }})</span>
                : </span
              ><span *ngIf="hasCustomerPriceRole; else noCustomerPriceRole">
                {{ order.customerPriceMax | currency : 'GBP' : 'symbol' : '1.2-2' }}
              </span>
              <ng-template #noCustomerPriceRole>
                <span *ngIf="order.isFixPrice; else rangePrice">
                  {{ order.customerPrice | currency : 'GBP' : 'symbol' : '1.2-2' }}
                </span>
                <ng-template #rangePrice>
                  <span *ngIf="!order.isFixPrice">
                    {{ order.customerPriceMin | currency : 'GBP' : 'symbol' : '1.2-2' }}
                    - {{ order.customerPriceMax | currency : 'GBP' : 'symbol' : '1.2-2' }}
                  </span>
                </ng-template>
              </ng-template>
            </span>
            <span *ngIf="!order.isGuranteeFulfilment" style="color: gray">*</span>
            <button
              type="button"
              pButton
              (click)="getPriceLog(order)"
              label="Debug"
              style="margin-left: 10px"
              *ngIf="isDebug"
            ></button>
          </div>
          <div
            style="text-align: left; margin-top: 10px"
            *ngIf="newJobs[0].tasks[0].taskTypeId == 15 || newJobs[0].tasks[0].taskTypeId == 16"
          >
            <span style="font-size: 20px">
              <span style="font-weight: bold"
                >Inspection:
                {{ getShortAddress(order.tasks[0].pickupLocation) }}
              </span>
              :
              <span>
                {{ order.inspectionCharge | currency : 'GBP' : 'symbol' : '1.2-2' }}
              </span>
            </span>
          </div>
        </li>
      </ul>
      <p>We will get your order fulfilled as cheaply as possible.</p>
      <div *ngIf="newJobs && newJobs.length > 0 && newJobs[0].tasks && newJobs[0].tasks.length > 0">
        <p
          *ngIf="
            newJobs[0].tasks[0].taskTypeId != 4 &&
            newJobs[0].tasks[0].taskTypeId != 3 &&
            newJobs[0].tasks[0].taskTypeId != 8
          "
        >
          The upper range is the maximum it will cost you. If we get it cheaper, we'll invoice you
          for less.
        </p>
        <p *ngIf="newJobs[0].tasks[0].taskTypeId == 4">
          The above price covers the miles from start location to end location. In addition to this,
          charges will be added for miles travelled to and from the job by the agent back to their
          base. This mileage is verified by Engineius and charged at roughly £1.60 per mile.
        </p>
        <p *ngIf="newJobs[0].tasks[0].taskTypeId == 3">
          For multi-vehicle transported movements, we will contact you to confirm the best price we
          have available. Note that for multi-vehicle movements, the price per vehicle will likely
          be significantly lower than that displayed above.
        </p>

        <p *ngIf="newJobs[0].tasks[0].taskTypeId == 8">
          For Vehicle Recovery, Engineius will quote the best price available for completion. We
          will contact you as soon as possible with a quote regarding the fulfilment of the recovery
          order.
        </p>

        <p>
          We reserve the right to revise the quote shown on screen for movements involving
          non-mainland UK locations.
        </p>
      </div>
    </div>
    <div>
      <p>
        This movement will take place under our
        <a
          style="color: #3b5169; cursor: pointer; text-decoration: underline"
          (click)="tcService.downloadTermsOfUse()"
          >standard terms & conditions</a
        >, unless you have a bespoke agreement in place with us.
      </p>
      <div class="ui-g-12">
        <img
          src="assets/images/web_login_backround.png"
          style="margin-bottom: -20px; margin-left: 240px; width: 60%; height: auto"
        />
      </div>
    </div>
    <div class="ui-g-12">
      <p-table
        [value]="pricelog"
        [lazy]="false"
        [paginator]="false"
        rowHover="false"
        resizableColumns="true"
        [style]="{ width: '100%' }"
        [class.no-zebra-shading]="true"
        *ngIf="pricelog"
        scrollable="true"
        scrollHeight="400px"
      >
        <ng-template pTemplate="header">
          <tr>
            <th>Log</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-item>
          <tr>
            <td>
              <span>{{ item }}</span>
            </td>
          </tr>
        </ng-template>

        <!--
        <p-column field="" header="Log" [editable]="false" [style]="{'width':'180px'}">
          <ng-template let-col let-data="rowData" let-ri="rowIndex" pTemplate="body">
            <span>{{data}}</span>
          </ng-template>
        </p-column>
        -->
      </p-table>
    </div>
  </div>
  <p-footer>
    <div style="float: left; color: gray" *ngIf="isExistNotGuranteed(newJobs)">
      *Fulfilment cannot be guaranteed
    </div>
    <button
      type="button"
      pButton
      icon="fa fa-check"
      (click)="submitOrderClicker.next()"
      [label]="'Submit Order(s)'"
      class="recovery-button-recover"
      [disabled]="calculatedPrice == null"
    ></button>
    <button
      type="button"
      pButton
      icon="fa fa-close"
      (click)="CancelSubmitOrders()"
      label="Cancel"
      class="recovery-button-new"
    ></button>
  </p-footer>
</p-dialog>
<!--EOF Order Pricing Dialog-->

<!--Pickup Sites-->
<p-dialog
  [header]="isPickupDlg ? 'Pick-up Sites' : 'Drop-off Sites'"
  [(visible)]="isShowSite"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '600px' }"
  (onHide)="clearFilter(dataTable)"
>
  <div class="ui-grid ui-grid-responsive ui-fluid">
    <div class="ui-g-12">
      <form (ngSubmit)="search()" style="width: 100%">
        <div class="ui-g filterPanel form-group">
          <div class="ui-g-4">
            <span class="md-inputfield filterItem">
              <input
                name="siteName"
                type="text"
                pInputText
                [(ngModel)]="filterVal.filters.siteName.value"
              />
              <label>Search</label>
            </span>
          </div>
          <div class="ui-g-5">
            <div style="display: flex; flex-direction: row; gap: 10px">
              <button pButton type="submit" label="Search" style="width: 150px"></button>
              <button
                pButton
                type="button"
                label="Clear"
                style="width: 150px"
                (click)="clearFilter(dataTable)"
              ></button>
            </div>
          </div>
        </div>
      </form>

      <p-table
        #dataTable
        [value]="page.items"
        [rows]="10"
        [paginator]="true"
        [pageLinks]="3"
        [rowsPerPageOptions]="[5, 10, 20]"
        selectionMode="single"
        [(selection)]="selectedSites"
        (onLazyLoad)="onGridLazyLoad($event)"
        [lazy]="true"
      >
        <ng-template pTemplate="header">
          <tr>
            <th>Sites</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
          <tr [pSelectableRow]="item" (dblclick)="selectSite(item, isPickupDlg)">
            <td>
              <div *ngIf="item.businessName != ''">
                <b>{{ item.siteName }}</b
                >&nbsp;&nbsp;&nbsp;{{ item.businessName }}, {{ item.address1 }} , {{ item.city }}
                {{ item.postcode | postcode }}
              </div>
              <div *ngIf="item.businessName == ''">
                <b>{{ item.siteName }}</b
                >&nbsp;&nbsp;&nbsp;{{ item.address1 }}, {{ item.city }}
                {{ item.postcode | postcode }}
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</p-dialog>
<!--EOF Pickup Sites-->

<!--Pickup Sites-->
<p-dialog
  [(visible)]="isShowMotWarning"
  [responsive]="true"
  [modal]="true"
  [closeOnEscape]="false"
  [showHeader]="false"
  [closable]="false"
  [style]="{ width: '600px' }"
>
  <div class="ui-grid ui-grid-responsive ui-fluid">
    <div class="ui-g-12 motWarningDlgHeader">WARNING</div>
    <div class="ui-g-12" style="margin-top: 40px">
      This vehicle does not have a valid MOT.<br /><br />
      To continue with this booking, you must ensure that<br /><br />

      1. The drop-off location is a MOT test station<br />
      2. A booking has been made for this vehicle<br /><br />
    </div>
    <div class="ui-g-12">
      Failure to ensure both of these requirements are in place will result in the driver being
      unable to carry out the movement and a full charge for cancellation being made.
    </div>
  </div>
  <div style="float: right">
    <button
      type="button"
      pButton
      label="Continue"
      (click)="motWarningContinue()"
      class="ui-button green-btn"
    ></button>
    <button type="button" pButton label="Cancel" (click)="motWarningCancel()"></button>
  </div>
</p-dialog>

<!--Confirmation Dialog-->
<p-confirmDialog
  header="Confirmation"
  icon="fa fa-icon-circle"
  [style]="{ width: '425px' }"
  acceptLabel="Save"
  rejectLabel="Cancel"
></p-confirmDialog>
<!--EOF Confirmation Dialog-->

<p-dialog
  [(visible)]="isShowAdditionalStepForm"
  header="New Additional Requirement"
  [responsive]="true"
  [modal]="true"
  [closeOnEscape]="false"
  [closable]="true"
  (onHide)="isShowAdditionalStepForm = false"
  [style]="{ width: '425px' }"
  *ngIf="addCustomStepForm"
>
  <small
    >This will appear after
    <b>{{ addCustomStepForm.controls.parentEngineiusStepName?.value }}</b></small
  >
  <form [formGroup]="addCustomStepForm" autocomplete="off" ngClass="mt-4 mb-2">
    <div ngClass="ui-g-12">
      <input
        pInputText
        id="name"
        formControlName="name"
        placeholder="Name"
        maxlength="250"
        class="ui-g-12"
      />
    </div>
    <div class="clearfix"></div>
    <div class="mt-4">
      <div ngClass="ui-g-6">
        <p-checkbox
          formControlName="allowComments"
          label="Allow Comments"
          binary="true"
        ></p-checkbox>
      </div>
      <div ngClass="ui-g-6">
        <p-checkbox formControlName="allowPhotos" label="Allow Photos" binary="true"></p-checkbox>
      </div>
    </div>
  </form>
  <div class="clearfix"></div>
  <hr ngClass="mt-4" />
  <div ngClass="mt-4">
    <button
      type="button"
      pButton
      label="Cancel"
      (click)="isShowAdditionalStepForm = false"
      ngClass="pull-right blue-grey-btn"
    ></button>
    <button
      type="button"
      (click)="addCustomAction(addCustomStepForm.value)"
      pButton
      label="Save"
      [disabled]="!addCustomStepForm.controls.name?.value?.trim()"
      class="pull-right ui-button green-btn"
    ></button>
    <div class="clearfix"></div>
  </div>
</p-dialog>

<!--Pickup and dropoff contact numbers missing -->
<p-dialog
  [header]="contactNumberDialogHeader"
  [(visible)]="showContactNumberDialog"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '400px' }"
>
  <div class="ui-grid ui-grid-responsive ui-fluid">
    <div class="ui-g-12">
      <div>
        Our drivers are asked to always contact the pick-up and drop-off contacts to ensure the
        vehicle and a person are available and ready. Failure to provide this information could
        result in the job not being taken, handed back by the driver or aborted with costs payable.
        If you do not have the information to hand on booking, please add to the job as soon as
        possible or add explicit collection or drop-off notes
      </div>
      <div class="ui-g-12 pull-right">
        <div class="pull-right">
          <button
            pButton
            (click)="closeContactNumberWarningDialog(true)"
            label="Yes, Next"
            class="red-btn"
          ></button>
        </div>
        <div class="pull-right">
          <button
            pButton
            label="No, Cancel"
            (click)="closeContactNumberWarningDialog(false)"
            class="pull-right"
          ></button>
        </div>
      </div>
    </div>
  </div>
</p-dialog>

<!--MoDel PIN entry-->
<p-dialog
  header="Next step without MoDel PIN?"
  [(visible)]="isShowMoDelDialog"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '400px' }"
>
  <div class="ui-grid ui-grid-responsive ui-fluid">
    <div class="ui-g-12">
      <div>
        This order has no MoDel PIN. Without this PIN we may not be able to complete MoDel. Are you
        sure you want to go to the next step without a PIN?
      </div>
      <div class="ui-g-12 pull-right">
        <div class="pull-right">
          <button
            pButton
            (click)="closeModelPinDialog()"
            label="Yes, Next"
            class="cyan-btn"
          ></button>
        </div>
        <div class="pull-right">
          <button
            pButton
            label="No, Cancel"
            (click)="closeMoDelDialog()"
            class="pull-right"
          ></button>
        </div>
      </div>
    </div>
  </div>
</p-dialog>
<!--MoDel PIN entry-->

<!--Render Pickup / Drop off steps here-->
<ng-template #step_item let-step="step" let-isPickup="isPickup" let-isLastStep="isLastStep">
  <div
    class="ui-g-12"
    (mouseover)="handleMouseEnter($event, step)"
    (mouseleave)="handleMouseLeave($event, step)"
  >
    <div class="ui-g-9">
      <div *ngIf="!step.isEngineiusStep && !step.isCustomStep">
        <p-checkbox
          *ngIf="isPickup"
          value="{{ step.id }}"
          label="{{ step.name }}"
          [name]="'pickupSpecificStepGroup'"
          [(ngModel)]="selectedPickupSpecificSteps"
        ></p-checkbox>

        <p-checkbox
          *ngIf="!isPickup"
          value="{{ step.id }}"
          label="{{ step.name }}"
          [name]="'dropoffSpecificStepGroup'"
          [(ngModel)]="selectedDropoffSpecificSteps"
        ></p-checkbox>
        <br />
        <div [ngStyle]="{ 'margin-left': '30px', 'margin-top': '7px' }">
          <small>{{ step.organisationSpecificStep?.description }}</small>
        </div>
      </div>
      <div *ngIf="!step.isEngineiusStep && step.isCustomStep">
        <p-checkbox
          *ngIf="isPickup"
          value="{{ step.id }}"
          label="{{ step.name }}"
          [name]="'pickupCustomActionGroup'"
          [(ngModel)]="selectedPickupCustomActions"
        ></p-checkbox>
        <p-checkbox
          *ngIf="!isPickup"
          value="{{ step.id }}"
          label="{{ step.name }}"
          [name]="'dropoffCustomActionGroup'"
          [(ngModel)]="selectedDropoffCustomActions"
        ></p-checkbox>
      </div>
      <div *ngIf="step.isEngineiusStep">
        <p-checkbox
          value="{{ step.id }}"
          [(ngModel)]="defaultTaskStepsChecked"
          label="{{ step.name }}"
          [ngModelOptions]="{ standalone: true }"
          binary="true"
          disabled="true"
        >
        </p-checkbox>
      </div>
    </div>

    <div class="ui-g-3">
      <div title="Add an additional requirement here" *ngIf="step.isEngineiusStep && !isLastStep">
        <span class="pi pi-plus link" (click)="handleAdditionalRequirementClick(step)"></span>
      </div>
      <div *ngIf="!step.isEngineiusStep && !step.isCustomStep">
        <span
          [ngClass]="step.showDetails ? 'pi pi-angle-up link' : 'pi pi-angle-down link'"
          (click)="handleShowDetails(step)"
        ></span>
      </div>
      <div *ngIf="step.isCustomStep">
        <!-- <span class="fa fa-image">{{step.allowPhotos}}</span> <span class="fa fa-pencil">{{step.allowComments}}</span> -->
      </div>
    </div>
  </div>
  <div class="clearfix"></div>
  <div *ngIf="step.showDetails && step.organisationSpecificStep" ngClass="">
    <p-fieldset legend="Details">
      <div class="ui-g-12">
        <div class="ui-g-6 pb-1">
          <i class="fa fa-check checklist-label" *ngIf="step.organisationSpecificStep.isStep"></i>
          <i class="fa fa-times checklist-label" *ngIf="!step.organisationSpecificStep.isStep"></i>
          Require user confirmation
        </div>
        <div class="ui-g-6 pb-1">
          <i
            class="fa fa-check checklist-label"
            *ngIf="step.organisationSpecificStep.allowFreeText"
          ></i>
          <i
            class="fa fa-times checklist-label"
            *ngIf="!step.organisationSpecificStep.allowFreeText"
          ></i>
          Free text Allowed
        </div>
        <div class="ui-g-6 pb-1">
          <i
            class="fa fa-check checklist-label"
            *ngIf="step.organisationSpecificStep.isFreeTextMandatory"
          ></i>
          <i
            class="fa fa-times checklist-label"
            *ngIf="!step.organisationSpecificStep.isFreeTextMandatory"
          ></i>
          Response is required
        </div>
        <div class="ui-g-6 pb-1">
          <i class="fa fa-check checklist-label" *ngIf="step.organisationSpecificStep.hasPII"></i>
          <i class="fa fa-times checklist-label" *ngIf="!step.organisationSpecificStep.hasPII"></i>
          Response includes a PII
        </div>
        <div class="ui-g-6 pb-1">
          <i
            class="fa fa-check checklist-label"
            *ngIf="step.organisationSpecificStep.minPhotosAllowed"
          ></i>
          <i
            class="fa fa-times checklist-label"
            *ngIf="!step.organisationSpecificStep.minPhotosAllowed"
          ></i>
          Photos allowed
        </div>
        <div
          class="ui-g-6 pb-1"
          *ngIf="
            step.organisationSpecificStep.minPhotosAllowed != null &&
            step.organisationSpecificStep.minPhotosAllowed > 0
          "
        >
          <span class="checklist-label">{{ step.organisationSpecificStep.minPhotosAllowed }}</span>
          Minimum photo(s) required
        </div>
        <div class="ui-g-6 pb-1" *ngIf="step.organisationSpecificStep.ancillaryStepId">
          <i class="fa fa-check checklist-label"></i>
          Ancillary Step: {{ step.organisationSpecificStep.ancillaryStep.stepName || 'Not Set' }}
        </div>
      </div>

      <div
        ngClass="ui-g-12 mt-4"
        *ngIf="
          step.organisationSpecificStep.answerTemplates &&
          step.organisationSpecificStep.answerTemplates.length > 0
        "
      >
        <div ngClass="qa-answer-details-container">
          <b>{{ step.organisationSpecificStep.questionTypeName }} Answer Choices</b>

          <p-table [value]="step.organisationSpecificStep.answerTemplates" styleClass="mt-1">
            <ng-template pTemplate="header">
              <tr>
                <th></th>
                <th>Allow Photos</th>
                <th>Min # Photos</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-data>
              <tr [pSelectableRow]="data">
                <td>{{ data.answer.text }}</td>
                <td>
                  <p-checkbox
                    binary="true"
                    [(ngModel)]="data.allowPhotos"
                    [ngModelOptions]="{ standalone: true }"
                    name="allowPhotos"
                    [disabled]="true"
                  ></p-checkbox>
                </td>
                <td>{{ data.minimumNumberOfPhotos }}</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </p-fieldset>
  </div>
</ng-template>
<ng-template #noMappingWarning>
  <div style="margin-bottom: 5px">
    <b>There are no checklists defined for this movement type.</b>
  </div>
</ng-template>

<p-overlayPanel #pickupSiteHoursForm class="no-padding" [dismissable]="true">
  <customer-sites-opening-times
    *ngIf="pickupSiteHoursFormGroup"
    [openingTimesForm]="pickupSiteHoursFormGroup"
    (onClose)="closePickupSiteHoursForm()"
    [disableFields]="disableAddressSearchPickupFields"
  ></customer-sites-opening-times>
</p-overlayPanel>

<p-overlayPanel #dropOffSiteHoursForm class="no-padding" [dismissable]="true">
  <customer-sites-opening-times
    *ngIf="dropOffSiteHoursFormGroup"
    [openingTimesForm]="dropOffSiteHoursFormGroup"
    (onClose)="closeDropOffSiteHoursForm()"
    [disableFields]="disableAddressSearchDropoffFields"
  ></customer-sites-opening-times>
</p-overlayPanel>

<duplicate-tasks-dialog
  *ngIf="showDuplicateTaskDialog"
  [registrationNumber]="registrationNumber"
  [tasks]="duplicateTasks"
  (continueEmitter)="duplicateTaskResponse($event)"
>
</duplicate-tasks-dialog>

<app-customer-sites-editor
  *ngIf="addressSearchPickupSiteEditor"
  [(visible)]="addressSearchPickupSiteEditor"
  (updatedSite)="selectSite($event, true)"
  [site]="addressSearchSiteTemplate"
  [source]="CustomerSiteEditorSource.CreateMovementPickup"
  [vehicleAddressSource]="pickupLocation"
  [contactInfo]="siteEditorContactInfo"
  [openingTimesForm]="pickupSiteHoursFormGroup"
></app-customer-sites-editor>

<app-customer-sites-editor
  *ngIf="addressSearchDropoffSiteEditor"
  [(visible)]="addressSearchDropoffSiteEditor"
  (updatedSite)="selectSite($event, false)"
  [site]="addressSearchSiteTemplate"
  [source]="CustomerSiteEditorSource.CreateMovementDropoff"
  [vehicleAddressSource]="dropoffLocation"
  [contactInfo]="siteEditorContactInfo"
  [openingTimesForm]="dropOffSiteHoursFormGroup"
></app-customer-sites-editor>
